import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

export class LanguageLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    switch (lang) {
      case 'en': {
        return Observable.of(
          {
            'promo-bundle-hosted-internet':'PROMO peoplefone BUNDLE: If you order peoplefone HOSTED and peoplefone INTERNET at the same time, you can tick this box get the product peoplefone SOFTPHONE for free for 12 months.',
            'uitext.offer.nda' : 'peoplefone provides the partner with the created offers as a Wordfile. These can be further processed by the partner. peoplefone does not guarantee the correctness of the wordfiles and cannot be held liable for any changes of prices, discounts or similar information.',
            'uitext.yes' : 'Yes',
            'uitext.no' : 'No',
            'uitext.offer.options.datasim.voice-option': 'VOICE Option',
            'uitext.offer.options.datasim.desc':
              'peoplefone DATASIM offers unlimited mobile internet for all kinds of smart devices, such as <br>laptops, tablets, LTE routers, GPS trackers, sensors, smartwatches, remote controls, LTE <br>surveillance cameras or mobile hotspots.'+
              '<br><br>Besides, with the peoplefone DATASIM your customers can use their mobile phone to make <br>calls via your peoplefone business number.'+
              '<br><br>You can find more information at <a target="_blank" href="https://www.peoplefone.com/en-ch/customer/products/internet/peoplefone-datasim">https://www.peoplefone.com/en-ch/customer/products/internet/peoplefone-datasim</a>',
            'uitext.offer.options.my-devices.desc': '',

            'uitext.offer.options.biz-flrat-hosted.desc': '<p>Thanks to peoplefone FLAT you can make calls at attractive flat rates in Switzerland and Europe.</p>\n' +
              '<br><p>The appropriate FLAT package can be ordered according to your individual call behavior.</p>'+
              '<br><p>"Hosted FLAT CH" for peoplefone HOSTED<br>"Hosted FLAT CH/EU" for peoplefone HOSTED</p>'+
              '<br><p>You can find the detailed offers and conditions under:<br>' +
              '<a target="_blank" href="https://www.peoplefone.com/en-ch/customer/prices-numbers/prices-offers/peoplefone-flat">https://www.peoplefone.com/en-ch/customer/prices-numbers/prices-offers/peoplefone-flat</a></p>',

            'uitext.offer.options.new-numbers.desc': '',

            'uitext.offer.options.internet-ipworldcom.desc': '',

            'uitext.offer.options.pf-devices.desc': '',

            'uitext.offer.options.biz-flrat-siptrunk.desc': '<p>Thanks to peoplefone FLAT you can make calls at attractive flat rates in Switzerland and Europe.</p>\n' +
              '<br><p>The appropriate FLAT package can be ordered according to your individual call behavior.</p>\n' +
              '<br><p>"SIP FLAT CH" for SIP-TRUNK products<br>"SIP FLAT CH/EU" for SIP-TRUNK products</p>'+
              '<br><p>You can find the detailed offers and conditions under:<br>' +
              '<a target="_blank" href="https://www.peoplefone.com/en-ch/customer/prices-numbers/prices-offers/peoplefone-flat">https://www.peoplefone.com/en-ch/customer/prices-numbers/prices-offers/peoplefone-flat</a></p>',

            'uitext.offer.options.disclaimer.desc': '<p><strong>General information<br /></strong>' +
                'With this offer tool you can create new offers. These offers can be edited ' +
                'online, duplicated and can be saved and printed as .docx file anytime. For each offer project you can define also the' +
                ' next steps, so you have an overview of all open offers.</p>\n' +
                '<p><strong>IMPORTANT: Liability<br /></strong>peoplefone has developed and tested this offer tool to its best knowledge' +
                ' and care. The employment of this tool does not exempt the user from carrying out the evaluation of the needs&nbsp; of ' +
                'the customer and the proposed solutions in a diligent and thorough manner.<br />peoplefone assumes no liability for the' +
                ' choosen products and services of these offers. In particular peoplefone is not liable for consequential damage like ' +
                'loss of profit or missed turnover. The offers created through this offer tool do not form a binding contract between' +
                ' you/your customer and peoplefone.</p>\n' +
                '<p>For more information and the &ldquo;General Terms and Conditions&rdquo; of peoplefone Ltd. , please visit our ' +
                'website <a target="_blank" href="https://www.peoplefone.ch">www.peoplefone.ch</a> anytime.</p>',

            'uitext.offer.options.pf-hosted.desc': '<p>peoplefone HOSTED is a virtual telephone system hosted by peoplefone. It replaces a classic telephone system (PBX). ' +
              'To define the required number of users of peoplefone HOSTED, enter the number of phones (IP Soft-/Hardphones), the number of Fax2Email, the number of analogue ' +
              'devices (including analogue fax machines), the number of centralised answering machines (excluding personal answering machines) and number of users on reserve.  ' +
              'The additional paying functions of peoplefone HOSTED IVR, peoplefone SOFTPHONE and peoplefone CONNECTOR can also be calculated in the offer. </p>',

            'uitext.offer.options.ported-numbers.desc': '<p>Telephone numbers of all Swiss area codes, 058 numbers, 08XX numbers and international telephone numbers can be ported to peoplefone.  09XX numbers cannot be ported.\t\n' +
              'For the number type, it is best to consult the invoice of the current provider:\t\n' +
              'Single number\t\n' +
              'Number block with 2 - 10 numbers \t\n' +
              'Business Line / DDI number block of at least 10 numbers having a range of 0-9.\t\n' +
              'Business Line TAG/GRA\t\n' +
              'The costs of porting international telephone numbers depend on the desired country (see website). These costs must be entered manually at the end under "Offer Summary".\t\n' +
              'Select the number type and the amount of numbers. You can add several number blocks.\t</p>',

            'uitext.offer.options.internet-cyberlink.desc': '<p>peoplefone INTERNET is a freely configurable Internet connection with or without managed services, in the FIBER or DSL network.</p>\n' +
              '<br>\n' +
              '<p>We offer the following services:</p>\n' +
              '<ul><li>Internet offer S</li>\n' +
              '<li>Internet offer M</li>\n' +
              '<li>Internet offer L</li>\n' +
              '<li>Internet offer with Managed Services</li></ul>\n' +
              '<br>\n' +
              '<p>The details, as well as all possible options, can be found at: <a target="_blank" href="https://www.peoplefone.com/en-ch/customer/products/internet/peoplefone-internet">https://www.peoplefone.com/en-ch/customer/products/internet/peoplefone-internet</a></p>',

            'uitext.offer.options.pf-siptrunk.desc': '<p>peoplefone SIP-TRUNK is the VoIP line for any kind of telephone system and is certified by the vast majority of telephone system manufacturers. </p>\n' +
              '<br><p>The advantages of peoplefone SIP-TRUNK:</p>\n' +
              '<ul><li>Ready for operation in a few minutes</li>\n' +
              '<li>Unlimited number of free voice channels</li>\n' +
              '<li>Free test for 30 days without obligation, incl. phone numbers and test credits</li>\n' +
              '<li>Call costs per minute or in the FLAT model</li>\n' +
              '<li>No contract commitment possible with pre-paid</li></ul>\n' +
              '<br><p>You can find more information at <a target="_blank" href="https://www.peoplefone.com/en-ch/customer/products/telephony/peoplefone-sip-trunk">https://www.peoplefone.com/en-ch/customer/products/telephony/peoplefone-sip-trunk</a></p> ',

            'uitext.offer.options.pf-3cx.desc': '<p>With the peoplefone 3CX HOSTED you upgrade to a more flexible and cost effective IP-Communications system, which convinces with an impressive UCC performance range!</p>\n' +
              '<p>The offer is available in 3 options.</p>\n' +
              '<p>Professional and Enterprise from 4 to 128 SC</p>\n' +
              '<p>For 3CX partners a 3CX without licence in 4 variants from Standard to Enterprise (hosting only)</p>\n' +
              '<br><p>The exact specifications of peoplefone 3CX HOSTED can be found here: <a target="_blank" href="https://www.peoplefone.com/en-ch/customer/products/telephony/peoplefone-3cx-hosted">https://www.peoplefone.com/en-ch/customer/products/telephony/peoplefone-3cx-hosted</a></p>',

            'uitext.offer.options.teams.desc': '<p>Microsoft TEAMS is a collaboration solution integrated with Microsoft 365, which, ' +
              'thanks to the "peoplefone MICROSOFT TEAMS" solution, can be connected to peoplefone\'s public telephone network.<br>' +
              'The prices for peoplefone MICROSOFT TEAMS depend on the number of desired simultaneous calls and number of features. ' +
              'A peoplefone MICROSOFT TEAMS subscription will be completed for a minimum of 2 voice channels and ' +
              'a minimum period of 12 months.</p>'+
              '<p>You can find more information at <a target="_blank" href="https://www.peoplefone.com/en-ch/customer/products/telephony/peoplefone-microsoft-teams">https://www.peoplefone.com/en-ch/customer/products/telephony/peoplefone-microsoft-teams</a></p>',

              'uitext.offer.options.operator-connect.desc': '<p>Direct integration into the Microsoft universe<br>Selecting peoplefone as provider in your Microsoft 365 account.</p>'+
              '<ul><li>With peoplefone OPERATOR CONNECT for Microsoft Teams you connect TEAMS directly to the peoplefone VoIP network.</li>'+
              '<li>Initial setup by peoplefone</li>' +
              '<li>Support by your local IT installer</li>'+
              '<li>Subscription per user</li></ul>'+
              '<p>You can find more information at <a target="_blank" href="https://www.peoplefone.com/en-ch/customer/products/telephony/peoplefone-microsoft-teams">https://www.peoplefone.com/en-ch/customer/products/telephony/peoplefone-microsoft-teams</a></p>',

              'uitext.offer.options.sbcplus.desc' : '<p>100% individualised solution for every company <br> SBCplus - the dedicated connection of telephony to TEAMS</p>'+
              '<ul><li>Own Session Border Controller</li>'+
              '<li>Local hosting</li>'+
              '<li>"Smart" integration phase</li>'+
              '<li>Connection of any conceivable third-party solutions (e.g. PBX, contact centre or alarm server)</li>'+
              '<li>Any additional customisation such as integration workshops or SLAs</li></ul>'+
              '<p>You can find more information at <a target="_blank" href="https://www.peoplefone.com/en-ch/customer/products/telephony/peoplefone-microsoft-teams">https://www.peoplefone.com/en-ch/customer/products/telephony/peoplefone-microsoft-teams</a></p>',

            'uitext.offer.options.pf-bundle.desc': '<p>peoplefone is the advantageous combination offer. You make calls with peoplefone HOSTED, the powerful telephone system of peoplefone and use the INTERNET offer of peoplefone in different service levels.</p>\n' +
              '<br><p>Peoplefone BUNDLE is available in 4 packages:</p>\n' +
              '<ul><li>BASIC BUSINESS PACK</li>\n' +
              '<li>ADVANCED BUSINESS PACK</li>\n' +
              '<li>FULL BUSINESS PACK</li>\n' +
              '<li>PROFESSIONAL BUSINESS PACK</li></ul>\n' +
              '<br><p>The exact specifications of peoplefone BUNDLE can be found here: <a target="_blank" href="https://www.peoplefone.com/en-ch/customer/prices-numbers/prices-offers/peoplefone-bundle">https://www.peoplefone.com/en-ch/customer/prices-numbers/prices-offers/peoplefone-bundle</a></p>',


              'uitext.offer.options.mobile.desc': '<p>peoplefone MOBILE offers attractive mobile subscriptions for Switzerland and for international use.</p>\n' +
              '<br><p> Up to 4 Xtra-Cards can be ordered for each subscription (for laptops, tablets and smartwatches) Existing mobile numbers can be transferred. With all subscriptions you are always travelling at full speed on the Sunrise 5G network.</p>\n' +

              '<br><p>You can find more information at: <a target="_blank" href="https://www.peoplefone.com/en-ch/customer/products/telephony/peoplefone-mobile">https://www.peoplefone.com/en-ch/customer/products/telephony/peoplefone-mobile</a></p>',
            /// LOGIN
            'GeneralInformationAndLimitOfResponsibility': 'Welcome to the peoplefone Offer Tool',

            /// LOGIN
            'WelcomePeoplefoneSalesTool': 'Welcome to the peoplefone Offer Tool',
            'AccessAccount': 'Access to your account',
            'LoginID': 'Login ID',
            'EnterReselerID': 'Enter your peoplefone user name',
            'Password': 'Password',
            'EnterReselerPW': 'Enter your user PW',
            'LOGIN': 'LOGIN',


            /// TOP BAR
            'Logout': 'Logout',


            /// SIDE BAR
            'AllOffers': 'All Offers',
            'FollowUp': 'Offer Follow Up',
            'Business': 'peoplefone FLAT',
            'BusinessFlatRates': 'peoplefone FLAT',
            'OfferSummary': 'Offer Summary',
            'Management': 'Management',
            'Previous': 'Previous',
            'Next': 'Next',
            'NewOffer': 'New offer',
            'ManagementOfTheDataBases': 'Databases / Settings',
            'ManagementOfPPDB': 'Mgmt of the peoplefone DB',
            'ManagementOfMyDevices': 'Mgmt of "My Devices" DB',
            'Settings': 'Settings',
            'LogoToShow': 'Logo to be displayed on the offers (128x128)',
            'ClickToBrowse': 'Click to choose an image',


            /// MY OFFER COMPONENT
            'MyOffers': 'My Offers',
            'Overview': 'Overview',
            'OverviewStatus': 'Overview Status',
            'People': 'Partner Contact Person',
            'Period': 'Period',
            'ALL': 'ALL',
            'LastYear': 'Last year',
            'CurrentYear': 'Current year',
            'ALLOffers': 'ALL Offers',
            'OPENOffers': 'OPEN Offers',
            'WONOffers': 'WON Offers',
            'LOSTOffers': 'LOST Offers',
            'ANY': 'ANY',
            'MonthlyCostRealized': 'Monthly costs realized',
            'UniqueCostRealized': 'Unique costs realized',
            'PotentialMonthlyCost': 'Potential monthly costs',
            'PotentialUniqueCost': 'Potential unique costs',
            'AddNewOffer': 'Add new offer',
            'SearchOffers': 'Search offers',
            'OfferStatus': 'Offer status',
            'OfferNumber': 'Offer number',
            'OfferID': 'Offer ID',
            'CompanyName': 'Company name',
            'ContactPerson': 'Contact Person',
            'PostalCode': 'Postal code',
            'City': 'City',
            'PhoneNumber': 'Phone number',
            'MobileNumber': 'Mobile number',
            'SalesStage': 'Sales stage',
            'NextStep': 'Next step',
            'DateFrom': 'Date - from',
            'DateTill': 'Date - till',
            'Search': 'Search',
            'Cancel': 'Cancel',
            'Reset': 'Reset',
            'SelectedOffers': 'Selected offers',
            'No': 'No',
            'OfferNr': 'Offer nr',
            'DateIN': 'Date IN',
            'Customer': 'Customer',
            'FollowUP': 'Follow Up',
            'Read': 'Read',
            'Edit': 'Edit',
            'Save': 'Save',
            'Duplicate': 'Duplicate',
            'Delete': 'Delete',
            'PrintOffer': 'Print offer',
            'ExportDocFile': 'Export .doc file',
            'NOOFFERRECORDFOUND': 'NO OFFER RECORD FOUND',

            /// FOLLOW UP COMPONENT
            'OfferFollowUp': 'Offer Follow Up',
            'Description': 'Description',
            'Date': 'Date',
            'Contact': 'Contact',
            'Visit': 'Visit',
            'SendOffer': 'Send offer',
            'WaitingFeedback': 'Waiting feedback',
            'ReminderNextDate': 'Reminder next date',
            'AddFollowUp': 'Add follow up',
            'EditOffer': 'Edit offer',
            'DeleteOffer': 'Delete Offer',
            'NoIpAdresse':'1 dynamic IP address',
            /// CUSTOMER PROFILE
            'CustomerProfile': 'Customer profile',
            'Company': 'Company',
            // 'CoordinatesOfTheCustomer': 'Coordinates of the customer',
            'Complement': 'Complement',
            'AddressNBR': 'Address / nbr',
            'FurtherAddress': 'Further address',
            'LastName': 'Last name',
            'FirstName': 'First name',
            'Position': 'Position',
            'EmailAddress': 'Email address',
            'LanguagePost': 'Language / post',
            'SelectLanguage': 'Select language',
            'Offer': 'Offer',
            'AddContactPerson': 'Add contact person',
            'Update': 'Update',


            /// SELECT WISHED SOLUTION
            'SelectTheWishedSolution': 'Select Offer Options',
            'PeoplephoneInternetIPworldcom': 'peoplefone Internet IP Worldcom',
            'PeoplephoneInternetCyberlink': 'peoplefone INTERNET',
            'PhoneNumbersToBePorted': 'Porting Phone Numbers',
            'NewPhoneNumbers': 'New Phone Numbers',
            'PeoplephoneHosted': 'peoplefone HOSTED',
            'PeoplephoneSIPTRUNK': 'peoplefone SIP-TRUNK',
            'FlatRateHOSTED': 'HOSTED',
            'FlatRateSIPTRUNK': 'SIP-TRUNK',
            'PeoplephoneDevicesDataBase': 'peoplefone Devices',
            'MyDevicesDataBase': 'My Devices',
            '3CX': '3CX',
            'MicrosoftTeams': 'Microsoft Teams',

            'end-to-end' : 'End-to-End QoS',
            'dsl-connection' : 'Upgrade for DSL connection',
            'sim-card' : 'SIM card incl. 2 GB Data*',

            /// PEOPLEPHONE IPworldcom
            'MyOffer': 'My offer',
            'Technology': 'Technology',
            'Bandwidths': 'Bandwidths',
            'IPaddress': 'IP addresses',
            'MonthlyCosts': 'Monthly costs',
            'UniqueCosts': 'Unique costs',
            'Internet': 'Internet',
            'Asymmetric': 'Asymmetric',
            'Symmetric': 'Symmetric',
            'SupportTime': 'Support time',
            'TypeOfRouter': 'Type of router',
            'AddInternetConnection': 'Add an Internet connection',
            'IPaddressIsIncluded': 'The first IP address is included in the price of each connection',

            'SLA Unmanaged Basic':  'SLA Unmanaged Basic',
            'SLA Managed Basic reactif': 'SLA Managed Basic reactive',
            'SLA Managed Standard proactif': 'SLA Managed Standard proactive',
            'SLA Managed Premium proactif': 'SLA Managed Premium proactive',

            'Select Router': 'Select Router',
            'Zyxel XMG 3927 G-Fast with WLAN': 'Zyxel XMG 3927 g.Fast with WLAN',
            'Zyxel XMG3927 G-fast Bridge': 'Zyxel XMG 3927 g.Fast Bridge',
            'Media-Converter CVT3112W2A': 'Media-Converter CVT3112W2A',
            'Zyxel XMG3927 G-fast WLAN PRECONFIGURE': 'Zyxel XMG 3927 g.Fast with WLAN preconfigured',
            'CTS FTTH-Gateway VRG5-31412 Passerelle fibre WLAN': 'CTS Fiber-Gateway VRG5-31412 with WLAN',
            'CTS FTTH-Gateway VRG5-31412 Passerelle fibre WLAN PRECONFIGURE': 'CTS Fiber-Gateway VRG5-31412 with WLAN preconfigured',

            /// MITEL HOSTED
            'presentatMitel': '<h2>peoplefone MITEL HOSTED - An all-in-one solution</h2>' +
              '      <p>peoplefone MITEL HOSTED can only be ordered and installed in cooperation with a certified Mitel partner.</p>',
            'MIVO-OPI' : 'Hosting of the application MIVO400 OIP (CTI), without licenses :',
            'abonnementMitel': 'Peoplefone MITEL HOSTED subscriptions',
            'MIVO-hosted': 'Hosting of the basic solution MIVO400VA Hosted, without licenses:',
            'machine-supp': '- 1 redundant virtual machine with VPN <br>' +
              '- Commissioning and maintenance',
            'aboonementSupp': 'Additional subscriptions',
            'MIVO-cloudLink': 'Hosting of the application MIVO400 CloudLink (integration GSM / MoMa), without licenses:',
            'MIVO-telework': 'Hosting of the application MIVO400 MBG (Teleworker), without licenses:',
            'capacite': 'For a capacity of:',
            'link_vpn': 'Hosting of the application MIVO400 OIP (CTI), without licenses:',

            'up to 125 terminals': 'up to 125 terminals',
            'up to 250 terminals': 'up to 250 terminals',
            'up to 1250 terminals': 'up to 1250 terminals',

            'up to 50 users': 'up to 50 users',
            'up to 300 users': 'up to 300 users',
            'up to 1200 users': 'up to 1200 users',

            /// PHONE NUMBERS TO BE PORTED
            'SelectHereAllTheRangesOfNumbersToBePortedByPeoplephone': 'Select here all the ranges of numbers to be ported by peoplefone',
            'ConnectionType': 'Number type',
            'totalCount': 'Total phone numbers',
            'Range': 'Range',
            'EconomyLine': 'Single number',
            'MultiLine': 'Number block 2-10',
            'BusinessLineDDI': 'Business Line - DDI',
            'SCBusinessLineGRA': 'SC Business Line GRA',
            'InternatNumbers': 'Internat. numbers',
            'AddNewRange': 'Add a new range',
            'Single number': 'Single number',
            'Number block 2-10': 'Number block 2-10',
            'Business Line > 10': 'Business Line > 10',
            'Business Line TAG/GRA': 'Business Line TAG/GRA',
            '058xxx numbers': '058XXX numbers',
            '08xx numbers': '08XX numbers',
            'Internat. numbers': 'Internat. Numbers',
            'Swiss phone number': 'Swiss phone number',
            /// NEW PHONE NUMBERS
            'TotalWishedNumbers': 'Total wished numbers',
            'OfferedNumbers': 'Offered numbers',
            'NiceNumber': 'Nice number',
            'Category': 'Category',
            'SelectAllTheRangesOfNewPeoplefonePhoneNumbersHere': 'Select all the ranges of new peoplefone phone numbers here',
            'PriceOnDemand': 'Price on demand',

            /// PEOPLEPHONE SIPTRUNK
            'setupCosts': 'Setup costs',
            'unlimited': 'Unlimited',

            /// PEOPLEPHONE HOSTED
            // tslint:disable-next-line:max-line-length
            'SelectHereTheNumberOfUsersFaxAnsweringMachinesReserveOfUsersAndIVRNode': 'Select here the number of users, fax, answering machines, reserve of users and IVR node',
            'Users': 'Users',
            'NumbersOfUsersIPTerminals': 'Numbers of users (IP Terminals)',
            'NumberOfFaxToEmailRequiresUser': 'Number of fax to email (requires 1 user)',
            'NumberOfAnalogRequiresUser': 'Number of analog (requires 1 user)',
            'NumberOfCentralizedVoiceMailRequiresUser': 'Number of centralized Voice mail (requires 1 user)',
            'ReserveOfUsers': 'Reserve of users',
            'TotalOfTheSelectedUsers': 'Total of the selected users',
            'TotalOfAvailableUsersInTheProposedHOSTEDSolution': 'Total of available users in the proposed HOSTED solution',
            'AllAnalogTerminalsRequiresCiscoSPA122Box': 'All analog Terminals requires 1 Cisco SPA 122 box',
            'NumberOfCiscoBoxWith2ConnectedAnalogsTerminals': 'Number of Cisco box with 2 connected analogs terminals',
            'NumberOfCiscoSPA122Box': 'Number of Cisco SPA 122 box',
            'AddTheNumberOfCiscoSPA122BoxInTheShopPage': '(add the number of Cisco SPA 122 box in the Shop page)',
            'PeoplephoneHostedIVR': 'peoplefone HOSTED IVR',
            'Nodes': 'Nodes',
            'NumberOfNodes': 'Number of nodes',
            'PeoplephoneHostedSummary': 'PEOPLEFONE HOSTED SUMMARY',
            'TotalOfUsers': 'Total of users',
            'TotalOfIVRNodes': 'Total of IVR nodes',
            'TotalMonthlyCosts': 'Total monthly costs',
            'TotalUniqueCosts': 'Total unique costs',

            'PeoplephoneSoftphone': 'peoplefone SOFTPHONE',
            'PeoplephoneConnectorStandard': 'peoplefone CONNECTOR Standard',
            'PeoplephoneConnectorApi': 'peoplefone CONNECTOR API',

            'TotalOfSoftphone' : 'Total of peoplefone SOFTPHONE users',
            'TotalConnectorStandard' : 'Total of peoplefone CONNECTOR Standard users',
            'TotalConnectorApi' : 'Total of peoplefone CONNECTOR API users',

            'quantityuser' : 'quantity of users',
            'AddPayingHosted' : 'Additional paying functions',
            'adresseInput' : 'Installation address ',
            /// FLAT RATE HOSTED
            // tslint:disable-next-line:max-line-length
            'SelectSubscriptionForBusinessFlatRatesForPeoplefoneHostedHere': 'Select the subscription for business flat rates for peoplefone HOSTED here',
            'TheFlatRatesForPeopleFoneHostedAreDefinedPerUser': 'The flat rates for peoplefone HOSTED are defined per user',
            'users': 'users',
            // tslint:disable-next-line:max-line-length
            'TheNumberOfSelectedFlatRatesLimitsTheNumberOfOutgoingVoiceChannels': 'The number of selected flat rates limits the number of outgoing voice channels',
            'CanBeAdjustedAtAnyTime': 'Can be adjusted at any time',
            'TheNumbersOfSelectedFlatRatesUsers': 'The numbers of selected flat rates users',
            'DoesNotLimitTheNumberOfIncommingVC': 'Does not limit the number of incomming voice channels',
            // tslint:disable-next-line:max-line-length
            'TheMonthlyIncludedMinutesOfTheSubscriptionAreAvailableForEveryoneWithinTheAccount': 'The monthly included minutes of the subscription are available for everyone within the account',
            // tslint:disable-next-line:max-line-length
            'TheMinimalContractPeriodForBusinessFlatRateIs12MonthsWithCancelationPeriodOf3Months': 'The minimal contract period for business flat rate is 12 months with a cancelation period of 3 months',
            'TotalMinutes': 'Total minutes',
            'NetworkType': 'FLAT',
            'NbrOfUsers': 'Nbr. of users',
            'FixNet': 'Fix Net',
            'MobileNet': 'Mobile Net',
            'Channels': 'Channels',


            /// FLAT RATE SIP-TRUNK
            // tslint:disable-next-line:max-line-length
            'SelectSubscriptionForBusinessFlatRatesForPeoplefoneSIPTRUNKHere': 'Select the subscription for business flat rates for peoplefone SIP-TRUNK here',
            'NbrOfVoiceChannels': 'Nbr. of voice channels',

            'TheFlatRatesForPeopleFoneSIPTRUNKAreDefinedPerVC': 'The flat rates for peoplefone SIP-TRUNK are defined per voice channel',
            // tslint:disable-next-line:max-line-length
            'TheNumberOfSelectedFlatRatesLimitsTheNumberOfOutgoingVC': 'The number of selected flat rates limits the number of outgoing voice channels',
            'VC': 'voice channels',
            'TheNumbersOfSelectedFlatRatesVC': 'The numbers of selected flat rates voice channels',



            /// POEPLEFONE DEVICES DATA BASE
            'MyBag': 'My Basket',
            'PeoplefoneDevicesDataBase': 'peoplefone devices data base',
            'Pos': 'Pos.',
            'Qty': 'Qty',
            'TotalIntermediary': 'Total intermediary',
            'ShippingCost': 'Shipping Costs',
            'Discount': 'Discount',
            'TotalWithoutTaxes': 'Total without taxes',
            'Taxes7': 'Taxes',
            'TotalWithTaxes': 'Total with taxes',
            'ContinueShopping': 'Cointinue Shopping',
            'GoToProjectSummary': 'Go to project summary',
            'DeskTelephone': 'Desk Telephone',
            'CordlessTelephone': 'Cordless Telephone',
            'VoIPAdapters': 'VoIP Adapters',
            'PCApp': 'PCApp / smartphone App',
            'Accessories': 'Accessories',
            'Router/Firewall/Switch': 'Router / Firewall / Switch',
            'MyArticles': 'My Articles',
            'DeviceAddedToBag': 'Device has been added to bag',
            'DeviceAddedToMyDevices': 'Device has been added to My Devices',
            'add-GB' : '*If the monthly volume is used up, an additional 1 GB is automatically activated. Every additional GB costs CHF 15.-.',


            // MY DEVICES
            'AddNewArticles': 'Add a new articles',
            'AddNewArticle': 'Add a new article',
            'SaveAddNextArticle': 'Save & Add Next Article',
            'Back': 'Back to list',


            // OFFER SUMMARY
            'Model': 'Model',
            'Details': 'Details',
            'Bandwidths/IPaddress': 'Bandwidths/IP address',
            'Total': 'Total',
            'SLA24/24': 'SLA',
            'PortedPhoneNumbers': 'Ported phone numbers',
            'Numbers': 'Numbers',
            'UsersNodes': 'Users / nodes',
            'CostsOfPP': 'Services/Products of peoplefone',
            'TotalCostsOfPP': 'Total services and products peoplefone ',
            'TotalMaterialsOfPP': 'Total services and products of the partner ',
            'DiscountMaterialsOfPP': 'Discount of services and products of the partner',
            'TotalDiscount': 'Total Discount (Unique Costs)',
            'TotalMaterialsOfPPDiscount': 'Total services and products of the partner (discount included)',
            'PPDevicesDataBase': 'Complementary Services/Products',
            'NiceNumbers': 'Nice numbers',
            'OfferConditionsText': '<b>This is only an offer.<br />' +
              'After successful acquisition of the project, the corresponding peoplefone contracts must be signed separately and sent to peoplefone.</b>',
            'OfferConditionsLabel': 'I understand the difference between offer and contract.',
            'exportHasNoVATLabel': 'Export the offer with no VAT included',


            // MANAGEMENT
            'ManagementPeoplefoneDevicesDataBase': 'Management of peoplefone Devices',

            // MANAGEMENT MY DEVICES
            'ManagementMyDevicesDataBase': 'Management of "My Devices"',

            // SUMMARY
            'CostsSummary': 'COSTS SUMMARY',
            'TotalOfMonthlyCosts(VAT)': 'Total Of Monthly Costs (VAT included)',
            'TotalOfUniqueCosts(VAT)': 'Total Of Unique Costs (VAT included)',
            'TotalCosts(VATincluded)': 'Total Costs (VAT included)',
            'VATAcronym': 'VAT',

            // EDIT DEVICES
            'Image': 'Image',
            'Link': 'Link',
            'TitleDescription': 'Title and description',
            'PurchasePrice': 'Purchase price',
            'SalesPrice': 'Sales price',
            'DeviceSaved': 'Device has been saved',
            'PleaseProvideProperPriceValue': 'Please provide proper price value !',

            // Peoplefone Bundle
            'BundleHeadline': 'peoplefone BUNDLE',
            'BundleType': 'Abonnement',
            'BundleOptions': 'Options',
            'BundleInternetProvider': 'Internet Provider',
            'BundleAddon': 'Extension',
            'BundlePortedNumbers': 'Numbers Porting',
            'BundlePortedNumbersNone': 'No Porting',
            'BundlePortedNumbersMSN': 'Multi Line',
            'BundlePortedNumbersDDI': 'Business Line',
            'BundleRouterText': 'The router is not included in the peoplefone BUNDLE and must be ordered separately. ' +
              'You can find our router options under "peoplefone products". You can also add more routers under "My Products".',
            'BundleIPWorldcom': 'IP Worldcom',
            'BundleCyberlink': 'Cyberlink',
            'BundleRouter': 'Router',
            'No router': 'No router',
            'Solution' : 'Solution',
            // Peolefone Microsoft Teams
            'TeamsHeadline': 'peoplefone MICROSOFT TEAMS Direct Routing',
            'OperatorConnectHeadline': 'peoplefone MICROSOFT TEAMS Operator Connect',
            'SBCplusHeadline': 'peoplefone MICROSOFT TEAMS SBCplus',
            'TeamsAmount': 'Amount',
            'TeamsUsers': 'Users',
            'TeamsSetup': 'peoplefone MICROSOFT TEAMS set-up',
            'TeamsSetupDesc': 'Initial set-up',

            // Peoplefone 3CX
            '3cx': '3CX',
            '3cxHeadline': 'peoplefone 3CX HOSTED',
            '3cxOptions': 'Options',
            '3cxType': 'Edition',
            '3cxTypeUnlicensed': 'Without license',
            '3cxTypeStandard': 'Standard - no longer available',
            '3cxTypeProfessional': 'Professional',
            '3cxTypeEnterprise': 'Enterprise',

            '3cxUnlicensed8' : 'Standard',
            '3cxUnlicensed16' : 'Medium',
            '3cxUnlicensed96' : 'Large',
            '3cxUnlicensed512' : 'Enterprise',

            '3cxTerm': 'Minimum contract period',
            '3cxTerm12': '12 months',
            '3cxTerm24': '24 months',
            '3cxSC': 'SC / Variant',
            '3cxSCs': 'SC',
            '3cxAddon': 'Extensions',
            '3cxAddonStorage': 'Additional storage space',
            '3cxAddonStorageNone': 'None',
            '3cxAddonStorageExtension64': '64 GB',
            '3cxAddonStorageExtension96': '96 GB',
            '3cxAddonStorageExtension128': '128 GB',
            '3cxSummary': 'Summary',
            '3cxMonths': 'Months',

            // peoplefone Internet
            'DSL/FIBER' : 'peoplefone Internet (DSL/FIBER)',

            //peoplefone MOBILE
            'MobileHeadline' : 'peoplefone MOBILE',
            'MobileSubscription' : 'Subscription',
            'Extra Cards' : 'Extra Cards',
            'Extra Cards Data' : 'Extra Cards (Data)',
            'Extra Cards Watch' : 'Extra Cards (Watch)',
          });
      }

      case 'de': {
        return Observable.of(
          {
            'promo-bundle-hosted-internet':'PROMO peoplefone BUNDLE: Bei gleichzeitiger Bestellung von peoplefone HOSTED und peoplefone INTERNET, können Sie dieses Kästchen ankreuzen und erhalten das Produkt peoplefone SOFTPHONE kostenlos für 12 Monate.',
            'uitext.offer.nda' : 'peoplefone stellt dem Partner die erstellten Offerten als Wordfile zur Verfügung. Diese können vom Partner weiterbearbeitet werden. peoplefone übernimmt bei der Weiterbearbeitung der Wordfiles keine Gewähr für deren Richtigkeit und kann nicht haftbar gemacht werden bei etwaigen Änderungen von Preisen, Rabatten oder ähnlichen Angaben.',
            'uitext.yes' : 'Ja',
            'uitext.no' : 'Nein',
            'uitext.offer.options.datasim.voice-option': 'Option VOICE',
            'uitext.offer.options.datasim.desc':
            'peoplefone DATASIM bietet unlimitiertes mobiles Internet für alle möglichen smarten Geräte, wie z.B.<br>Laptop, Tablet, LTE-Router, GPS-Tracker, Sensoren, Smartwatches, Fernsteuerungen<br>LTE-Überwachungskameras oder mobile Hotspots.'+
            '<br><br>Daneben können Ihre Kunden mit der peoplefone DATASIM Ihr Mobiltelefon nutzen,<br>um über Ihre peoplefone Geschäftsnummer zu telefonieren.'+
            '<br><br>Weitere Informationen finden Sie unter <a target="_blank" href="https://www.peoplefone.com/de-ch/kunden/produkte/internet/peoplefone-datasim">https://www.peoplefone.com/de-ch/kunden/produkte/internet/peoplefone-datasim</a>',


            'uitext.offer.options.my-devices.desc': '<p>Hier finden Sie zus&auml;tzliche und&nbsp; pers&ouml;nliche Produkte und ' +
                'Dienstleistungen, die Sie vorg&auml;ngig unter &laquo;Verwaltung der Datenbank&raquo; selbst erfasst bzw. bearbeitet ' +
                'haben.</p><p>In Verwaltung von &laquo;Meine Produkte&raquo; k&ouml;nnen eigene Beschreibungen und Preise definiert und ' +
                'neue Dienstleistungen und Produkte angelegt werden.</p>',

            'uitext.offer.options.biz-flrat-hosted.desc': '<p>Dank peoplefone FLAT telefonieren Sie zu attraktiven Flatrates in der Schweiz und Europa.</p>\n' +
              '<br><p>Das passende FLAT-Paket kann je nach individuellem Gesprächsverhalten bestellt werden.</p>'+
              '<br><p>"Hosted FLAT CH" für peoplefone HOSTED<br>"Hosted FLAT CH/EU" für peoplefone HOSTED</p>'+
              '<br><p>Die detailierten Angebote und Konditionen finden Sie unter:<br>' +
              '<a target="_blank" href="https://www.peoplefone.com/de-ch/kunden/preise-nummern/preise-angebote/peoplefone-flat">https://www.peoplefone.com/de-ch/kunden/preise-nummern/preise-angebote/peoplefone-flat</a></p>',

            'uitext.offer.options.new-numbers.desc': '<p>peoplefone bietet unterschiedliche Telefonnummern an:<br /><ul>' +
                '<li>Schweizer Nummern mit allen Schweizer Vorwahlen</li>' +
                '<li>Nationale 058-Nummern</li>' +
                '<li>Internationale Nummern von &uuml;ber 50 L&auml;nder: Die Kosten variieren von Land zu Land (siehe Webseite). Diese ' +
                'Kosten m&uuml;ssen manuell am Schluss bei &laquo;Offerte Zusammenfassung&raquo; eingegeben werden.</li>' +
                '<li>Spezialnummer (&laquo;sch&ouml;ne&raquo; Nummern mit gleichen Ziffern) haben einmalige Zusatzkosten je nach ' +
                'Tarifklasse (siehe Webseite).</li>' +
                '</ul>' +
                'W&auml;hlen Sie den Nummerntyp an, die Anzahl Nummern und Spezialnummer falls erw&uuml;nscht. Sie k&ouml;nnen mehrere ' +
                'Nummernbl&ouml;cke hinzuf&uuml;gen.</p>',

            'uitext.offer.options.internet-ipworldcom.desc': 'Dieses Angebot gilt nur für die Westschweiz.',

            'uitext.offer.options.pf-devices.desc': '<p>peoplefone empfiehlt Ihnen eine Auswahl von provisionnierten VoIP Ger&auml;ten.' +
                ' W&auml;hlen Sie aus den verschiedenen Kategorien und f&uuml;gen Sie diese in den Warenkorb ein.</p>' +
                '<p>Durch das Anklicken des Sterns wird ein Ger&auml;t in &laquo;Meine Produkte&raquo; hinzugef&uuml;gt.</p>',

            'uitext.offer.options.biz-flrat-siptrunk.desc': '<p>Dank peoplefone FLAT telefonieren Sie zu attraktiven Flatrates in der Schweiz und Europa.</p>\n' +
              '<br><p>Das passende FLAT-Paket kann je nach individuellem Gesprächsverhalten bestellt werden.</p>\n' +
              '<br><p>"SIP FLAT CH" für SIP-TRUNK Produkte<br>"SIP FLAT CH/EU" für SIP-TRUNK Produkte</p>'+
              '<br><p>Die detailierten Angebote und Konditionen finden Sie unter:<br>' +
              '<a target="_blank" href="https://www.peoplefone.com/de-ch/kunden/preise-nummern/preise-angebote/peoplefone-flat">https://www.peoplefone.com/de-ch/kunden/preise-nummern/preise-angebote/peoplefone-flat</a></p>',

            'uitext.offer.options.disclaimer.desc': '<p><strong>Allgemeine Informationen</strong><br />' +
                'Mit diesem Offert-Hilfsmittel erhalten Sie die M&ouml;glichkeit neue ' +
                'Offertanfragen zu erstellen. Sie gestalten jederzeit eine massgeschneiderte Offerte, indem Sie diese bearbeiten, ' +
                'duplizieren und danach als Datei .docx ausdrucken. Im &laquo;Offer Tool&raquo; planen Sie auch n&auml;chste Schritte im ' +
                'Verhandlungsprozess und erhalten einen &Uuml;berblick der offenen Offertanfragen.</p>' +
                '<p><strong>WICHTIG: Haftungsausschluss</strong><br />peoplefone hat dieses Offert-Hilfsmittel nach bestem Wissen und ' +
                'Gewissen entwickelt und getestet. Die Anwendung des &laquo;Offer Tool&raquo; befreit den Benutzer nicht von seiner ' +
                'Sorgfalts- und Pr&uuml;fungspflicht zwischen den Bed&uuml;rfnissen des Kunden und den vorgeschlagenen L&ouml;sungen.' +
                '<br />peoplefone &uuml;bernimmt keine Verantwortung noch Haftung f&uuml;r die ausgew&auml;hlten Dienstleistungen und' +
                ' Produkte dieser Offerten. Insbesondere ist peoplefone nicht haftbar f&uuml;r eventuelle indirekte Sch&auml;den (wie' +
                ' zum Beispiel entgangenen Gewinn, entgangene Ums&auml;tze oder Verm&ouml;gensfolgesch&auml;den) in Folge der ' +
                'vorgeschlagenen L&ouml;sungen. Die Offerten, die durch dieses &laquo;Offer Tool&raquo; erstellt werden, stellen keinen ' +
                'bindenden Vertrag zwischen Ihnen/Ihren Kunden und peoplefone dar.</p>\n' +
                '<p>Detailliertere Informationen sowie die geltenden &laquo;Allgemeine Gesch&auml;ftsbedingungen&raquo; der peoplefone AG' +
                ' finden Sie jederzeit online auf <a target="_blank" href="https://www.peoplefone.ch">www.peoplefone.ch</a></p>',

            'uitext.offer.options.pf-hosted.desc': '<p>peoplefone HOSTED ist eine virtuelle Telefonanlage bei peoplefone gehostet. Sie ersetzt eine klassische Telefonanlage (PBX).\n' +
              'Um die benötigte Anzahl Benutzer von peoplefone HOSTED zu definieren, geben Sie die Anzahl Telefonapparate (IP Soft-/Hardphones), ' +
              'die Anzahl Fax2Email, die Anzahl analoger Geräte (inklusive analoge Faxgeräte), die Anzahl zentralisierter Anrufbeantworter ' +
              '(exklusive persönliche Anrufbeantworter) und Anzahl Benutzer auf Reserve ein. Die zusätzlichen kostenpflichtigen Funktionen von peoplefone HOSTED IVR, ' +
              'peoplefone SOFTPHONE und peoplefone CONNECTOR können ebenfalls im Angebot berechnet werden.</p>',

            'uitext.offer.options.ported-numbers.desc': '<p>Es&nbsp; k&ouml;nnen Telefonnummern aller Schweizer Vorwahlen, 058-Nummern, ' +
                '08XX-Nummern und internationale Telefonnummern zu peoplefone portiert werden.&nbsp; Es k&ouml;nnen keine 09XX-Nummern ' +
                'portiert werden.</p>\n' +
                '<p>F&uuml;r den Nummerntyp konsultieren Sie am besten die Rechnung des heutigen Anbieters:</p>' +
                '<ul>' +
                '<li>Economy Line / analoge Einzelnummer</li>' +
                '<li> Multi Line / ISDN Nummernblock von 3, 5 oder 10 Nummern</li>' +
                '<li>Business Line / DDI Nummernblock von mindestens 10 Nummern, die einen Bereich von 0-9 haben</li>' +
                '<li>Business Line TAG/GRA mit einer Nummer auf Spezialschaltung &laquo;Teilnehmeranschlussgruppe&raquo; </li>' +
                '</ul>' +
                '<p>Die Kosten der Portierung von internationalen Telefonnummern h&auml;ngen vom gew&uuml;nschten Land ab ' +
                '(siehe Webseite). Diese Kosten m&uuml;ssen manuell am Schluss bei &laquo;Offerte Zusammenfassung&raquo; eingegeben ' +
                'werden.<br />W&auml;hlen Sie den Nummerntyp an und die Anzahl Nummern. Sie k&ouml;nnen mehrere Nummernbl&ouml;cke ' +
                'hinzuf&uuml;gen.</p>',

            'uitext.offer.options.internet-cyberlink.desc': '<p>peoplefone INTERNET ist ein frei konfigurierbarer Internetanschluss mit oder ohne Managed Services, im FIBER oder DSL-Netz.</p>\n' +
              '<br>\n' +
              '<p>Wir bieten folgende Angebote:</p>\n' +
              '<ul><li>Internetangebot S</li>\n' +
              '<li>Internetangebot M</li>\n' +
              '<li>Internetangebot L</li>\n' +
              '<li>Internetangebot mit Managed Services</li></ul>\n' +
              '<br>\n' +
              '<p>Die Details, sowie alle möglichen Optionen finden Sie unter: <a target="_blank" href="https://www.peoplefone.com/de-ch/kunden/produkte/internet/peoplefone-internet">https://www.peoplefone.com/de-ch/kunden/produkte/internet/peoplefone-internet</a></p>',

            'uitext.offer.options.pf-siptrunk.desc': '<p>peoplefone SIP-TRUNK ist die VoIP-Leitung für jegliche Art von Telefonanlage und ist von den allermeisten Telefonanlagen-Herstellern zertifiziert.</p> \n' +
              '<br><p>Die Vorteile von peoplefone SIP-TRUNK:</p>\n' +
              '<ul><li>In wenigen Minuten betriebsbereit</li>\n' +
              '<li>Unbegrenzte Anzahl von kostenlosen Sprachkanälen</li>\n' +
              '<li>Unverbindlich gratis testen für 30 Tage, inkl. Telefonnummern und Testguthaben</li>\n' +
              '<li>Gesprächskosten pro Minute oder im FLAT-Model</li>\n' +
              '<li>Ohne Vertragsbindung möglich mit Pre-Paid</li></ul>\n' +
              '<br><p>Mehr Infos finden Sie unter <a target="_blank" href="https://www.peoplefone.com/de-ch/kunden/produkte/telefonie/peoplefone-sip-trunk">https://www.peoplefone.com/de-ch/kunden/produkte/telefonie/peoplefone-sip-trunk</a></p> ',

            'uitext.offer.options.pf-3cx.desc': '<p>Mit der peoplefone 3CX HOSTED steigen Sie auf ein flexibler und kostengünstiger IP-Communications-System um, welches mit einem beeindruckenden UCC-Leistungsumfang überzeugt!</p>\n' +
              '<p>Das Angebot ist in 3 Optionen erhältlich.</p>\n' +
              '<p>Professional und Enterprise von 4 bis 128 SC</p>\n' +
              '<p>Für 3CX Partner eine 3CX ohne Lizenz in 4 Varianten von Standard bis Enterprise (nur Hosting)</p>\n' +
              '<br><p>Die genauen Spezifikationen von peoplefone 3CX HOSTED finden Sie hier: <a target="_blank" href="https://www.peoplefone.com/de-ch/kunden/produkte/telefonie/peoplefone-3cx-hosted">https://www.peoplefone.com/de-ch/kunden/produkte/telefonie/peoplefone-3cx-hosted</a></p>',

            'uitext.offer.options.teams.desc': '<p>Microsoft TEAMS ist eine in Microsoft 365 integrierte Collaboration-Lösung, ' +
              'die dank der "peoplefone MICROSOFT TEAMS" -Lösung mit dem öffentlichen Telefonnetz von peoplefone verbunden werden kann.<br>' +
              'Die Preise für peoplefone MICROSOFT TEAMS sind abhängig von der gewünschten Anzahl gleichzeitiger Gespräche und Anzahl Features. ' +
              'Ein peoplefone MICROSOFT TEAMS Abonnement wird für mindestens 2 Sprachkanäle für 12 Monate abgeschlossen.</p>'+
              '<p>Weitere Informationen finden Sie unter <a target="_blank" href="https://www.peoplefone.com/de-ch/kunden/produkte/telefonie/peoplefone-microsoft-teams">https://www.peoplefone.com/de-ch/kunden/produkte/telefonie/peoplefone-microsoft-teams</a></p>',

            'uitext.offer.options.operator-connect.desc': '<p>Direkte Integration in das Microsoft-Universum<br>Wählen Sie peoplefone als Provider in Ihrem Microsoft 365 Konto.</p>'+
              '<ul><li>Mit peoplefone OPERATOR CONNECT for Microsoft Teams verbinden Sie TEAMS direkt mit dem peoplefone VoIP-Netzwerk.</li>'+
              '<li>Ersteinrichtung durch peoplefone</li>' +
              '<li>Unterstützung durch Ihren lokalen IT-Installateur</li>'+
              '<li>Abonnement pro Benutzer</li></ul>'+
              '<p>Weitere Informationen finden Sie unter <a target="_blank" href="https://www.peoplefone.com/de-ch/kunden/produkte/telefonie/peoplefone-microsoft-teams">https://www.peoplefone.com/de-ch/kunden/produkte/telefonie/peoplefone-microsoft-teams</a></p>',

              'uitext.offer.options.sbcplus.desc' : '<p>100% individualisierte Lösung für jedes Unternehmen <br> SBCplus - die dedizierte Anbindung der Telefonie an TEAMS</p>'+
              '<ul><li>Eigener Session Border Controller</li>'+
              '<li>Lokales Hosting</li>'+
              '<li>"Smarte" Integrationsphase</li>'+
              '<li>Anbindung von allen denkbaren Drittlösungen (z.B. PBX, Contact Center oder Alarmserver)</li>'+
              '<li>Eventuelle zusätzliche Anpassungen wie Integrationsworkshops oder SLAs</li></ul>'+
              '<p>Weitere Informationen finden Sie unter <a target="_blank" href="https://www.peoplefone.com/de-ch/kunden/produkte/telefonie/peoplefone-microsoft-teams">https://www.peoplefone.com/de-ch/kunden/produkte/telefonie/peoplefone-microsoft-teams</a></p>',

            'uitext.offer.options.pf-bundle.desc': '<p>peoplefone ist das vorteilhafte Kombiangebot. Sie telefonieren dabei mit peoplefone HOSTED, der leistungsfähigen Telefonanlage von peoplefone und nutzen das INTERNET-Angebot von peoplefone in verschiedenen Leistungenstufen.</p>\n' +
              '<br><p>Peoplefone BUNDLE gibt es in 4 Paketen:</p>\n' +
              '<ul><li>BASIC BUSINESS PACK</li>\n' +
              '<li>ADVANCED BUSINESS PACK</li>\n' +
              '<li>FULL BUSINESS PACK</li>\n' +
              '<li>PROFESSIONAL BUSINESS PACK</li></ul>\n' +
              '<br><p>Die genauen Spezifikationen von peoplefone BUNDLE finden Sie hier: <a target="_blank" href="https://www.peoplefone.com/de-ch/kunden/preise-nummern/preise-angebote/peoplefone-bundle">https://www.peoplefone.com/de-ch/kunden/preise-nummern/preise-angebote/peoplefone-bundle</a></p> ',


              'uitext.offer.options.mobile.desc': '<p>peoplefone MOBILE bietet attrakive Mobile Abonnemente für die Schweiz und für den internationel Gebrauch.</p>\n' +
              '<br><p>Zu jedem Abo können bis zu 4 Xtra-Cards bestellt werden (für Laptops, Tablets und Smartwatches) Bestehende Mobilenummern können übernommen werden. Mit allen Abos ist man Immer mit vollem Speed im 5G-Netz von Sunrise unterwegs.</p>\n' +

              '<br><p>Weitere Informationen finden Sie unter: <a target="_blank" href="https://www.peoplefone.com/de-ch/kunden/produkte/telefonie/peoplefone-mobile">https://www.peoplefone.com/de-ch/kunden/produkte/telefonie/peoplefone-mobile</a></p>',
          /// DISCLAIMER
            'GeneralInformationAndLimitOfResponsibility': 'Willkommen im peoplefone Offer Tool',

            /// LOGIN
            'WelcomePeoplefoneSalesTool': 'Willkommen im peoplefone Offer Tool',
            'AccessAccount': 'Zugang zum Konto',
            'LoginID': 'Login ID',
            'EnterReselerID': 'Geben Sie Ihr peoplefone Benutzername ein',
            'Password': 'Passwort',
            'EnterReselerPW': 'Geben Sie Ihr Benutzer Passwort ein',
            'LOGIN': 'LOGIN',


            /// TOP BAR
            'Logout': 'Logout',


            /// SIDE BAR
            'AllOffers': 'Alle Offerten',
            'FollowUp': 'Offerte nachfassen',
            'Business': 'peoplefone FLAT',
            'BusinessFlatRates': 'Business Flat Rates',
            'OfferSummary': 'Offerte Zusammenfassung',
            'Management': 'Verwaltung',
            'Previous': 'Zurück',
            'Next': 'Weiter',
            'NewOffer': 'Neue Offerte',
            'ManagementOfTheDataBases': 'Datenbank / Einstellungen',
            'ManagementOfPPDB': 'Verwaltung der peoplefone DB',
            'ManagementOfMyDevices': 'Verwaltung der DB "Meine Produkte"',
            'Settings': 'Einstellungen',
            'LogoToShow': 'Logo, das auf den Angeboten angezeigt wird (128x128)',
            'ClickToBrowse': 'Klicken Sie, um ein Bild auszuwählen',

            'Solution' : 'Lösung',
            /// MY OFFER COMPONENT
            'MyOffers': 'Meine Offerten',
            'Overview': 'Übersicht',
            'OverviewStatus': 'Übersicht Status',
            'People': 'Partner Kontaktperson',
            'Period': 'Periode',
            'ALL': 'Alle',
            'LastYear': 'Letztes Jahr',
            'CurrentYear': 'Dieses Jahr',
            'ALLOffers': 'Alle Offerten',
            'OPENOffers': 'Offene Offerten',
            'WONOffers': 'Gewonnene Offerten',
            'LOSTOffers': 'Verlorene Offerten',
            'ANY': 'Alle',
            'MonthlyCostRealized': 'Realisierte monatl. Kosten',
            'UniqueCostRealized': 'Realisierte einmalige Kosten',
            'PotentialMonthlyCost': 'Potentielle monatl. Kosten',
            'PotentialUniqueCost': 'Potentielle einmalige Kosten',
            'AddNewOffer': 'Neue Offerte hinzufügen',
            'SearchOffers': 'Suche Offerte',
            'OfferStatus': 'Offerten Status',
            'OfferNumber': 'Offerten Nr.',
            'OfferID': 'Offerten ID',
            'CompanyName': 'Firma Name',
            'ContactPerson': 'Kontaktperson',
            'PostalCode': 'Postleitzahl',
            'City': 'Ort',
            'PhoneNumber': 'Telefonnummer',
            'MobileNumber': 'Handynummer',
            'SalesStage': 'Verkaufsphase',
            'NextStep': 'Nächster Schritt',
            'DateFrom': 'Datum von',
            'DateTill': 'Datum bis',
            'Search': 'Suche',
            'Cancel': 'Löschen',
            'Reset': 'Zurücksetzen',
            'SelectedOffers': 'Ausgewählte Offerten',
            'No': 'Nummer',
            'OfferNr': 'Offerten Nr.',
            'DateIN': 'Datum Eingang',
            'Customer': 'Kunde',
            'FollowUP': 'Nachfassen',
            // 'Read': 'Read',
            'Edit': 'Bearbeiten',
            'Save': 'Speichern',
            'Duplicate': 'Kopieren',
            'Delete': 'Löschen',
            'PrintOffer': 'Offerte drucken',
            'ExportDocFile': 'Datei .doc exportieren',
            'NOOFFERRECORDFOUND': 'Keine Offerte gefunden',

            /// FOLLOW UP COMPONENT
            'OfferFollowUp': 'Offerte nachfassen',
            'Description': 'Beschreibung',
            'Date': 'Datum',
            'Contact': 'Kontakt',
            'Visit': 'Besuch',
            'SendOffer': 'Offerte senden',
            'WaitingFeedback': 'Warten auf Antwort',
            'ReminderNextDate': 'Erinnern nächstes Datum',
            'AddFollowUp': 'Nachfassen hinzufügen',
            'EditOffer': 'Offerte bearbeiten',
            'DeleteOffer': 'Offerte löschen',
            'NoIpAdresse':'1 dynamische IP Adresse',

            /// CUSTOMER PROFILE
            'CustomerProfile': 'Kundenprofil',
            'Company': 'Firma',
            'FirstName': 'Vorname',
            'LastName': 'Nachname',
            'Position': 'Position',
            'EmailAddress': 'E-Mail',
            'LanguagePost': 'Korrespondenzsprache',
            'SelectLanguage': 'Sprache auswählen',
            'Offer': 'Offerte  ',
            'AddContactPerson': 'Kontaktperson hinzufügen',
            'Update': 'Aktualisieren',


            /// SELECT WISHED SOLUTION
            'SelectTheWishedSolution': 'Offertoptionen auswählen',
            'PeoplephoneInternetIPworldcom': 'peoplefone Internet IP Worldcom',
            'PeoplephoneInternetCyberlink': 'peoplefone INTERNET',
            'PhoneNumbersToBePorted': 'Portierung Telefonnummern',
            'NewPhoneNumbers': 'Neue Telefonnummern',
            'PeoplephoneSIPTRUNK': 'peoplefone SIP-TRUNK',
            'PeoplephoneHosted': 'peoplefone HOSTED',
            'FlatRateHOSTED': 'HOSTED',
            'FlatRateSIPTRUNK': 'SIP-TRUNK',
            'PeoplephoneDevicesDataBase': 'peoplefone Produkte',
            'MyDevicesDataBase': 'Meine Produkte',
            '3CX': '3CX',
            'MicrosoftTeams': 'Microsoft Teams',

            'end-to-end' : 'End-to-End QoS',
            'dsl-connection' : 'Aufrüstung für DSL-Anschluss',
            'sim-card' : 'SIM-Karte inkl. 2 GB Data*',

            /// PEOPLEPHONE IPworldcom
            'MyOffer': 'Meine Offerte ',
            'Technology': 'Technologie',
            'Bandwidths': 'Bandbreite',
            'IPaddress': 'IP Adressen',
            'MonthlyCosts': 'Monatl. Kosten',
            'UniqueCosts': 'Einmalige Kosten',
            'Internet': 'Internet',
            'Asymmetric': 'Asymmetrisch',
            'Symmetric': 'Symmetrisch',
            'SupportTime': 'Supportzeiten',
            'TypeOfRouter': 'Router Typ',
            'AddInternetConnection': 'Internetverbindung hinzufügen',
            'IPaddressIsIncluded': 'Die erste dynamische IP Adresse ist im Preis inbegriffen.',


            'SLA Unmanaged Basic':  'SLA Unmanaged Basic',
            'SLA Managed Basic reactif': 'SLA Managed Basic reaktiv',
            'SLA Managed Standard proactif': 'SLA Managed Standard proaktiv',
            'SLA Managed Premium proactif': 'SLA Managed Premium proaktiv',


            'Select Router': 'Router auswählen',
            'Zyxel XMG 3927 G-Fast with WLAN': 'Zyxel XMG 3927 g.Fast with WLAN',
            'Zyxel XMG3927 G-fast Bridge': 'Zyxel XMG 3927 g.Fast Bridge',
            'Media-Converter CVT3112W2A': 'Media-Converter CVT3112W2A',
            'Zyxel XMG3927 G-fast WLAN PRECONFIGURE': 'Zyxel XMG 3927 g.Fast mit WLAN vorkonfiguriert',
            'CTS FTTH-Gateway VRG5-31412 Passerelle fibre WLAN': 'CTS Fiber Gateway VRG5-31412 mit WLAN',
            'CTS FTTH-Gateway VRG5-31412 Passerelle fibre WLAN PRECONFIGURE': 'CTS Fiber Gateway VRG5-31412 mit WLAN vorkonfiguriert',


            /// PHONE NUMBERS TO BE PORTED
            // tslint:disable-next-line:max-line-length
            'SelectHereAllTheRangesOfNumbersToBePortedByPeoplephone': 'Wählen Sie hier die Nummernblöcke, die Sie zu peoplefone portieren möchten',
            'ConnectionType': 'Nummerntyp',
            'totalCount': 'Anzahl Telefonnummern',
            'Range': 'Bereich',
            'EconomyLine': 'Economy Line/Analog',
            'MultiLine': 'Multi Line/ISDN',
            'BusinessLineDDI': 'Business Line/DDI',
            'SCBusinessLineGRA': 'Business Line TAG',
            'InternatNumbers': 'Internat. Nummern',
            'AddNewRange': 'Neuen Block hinzufügen',
            'add-GB' : '*Ist das monatliche Volumen aufgebraucht, wird automatisch ein weiteres 1 GB freigegeben. Zusätzlich pro weiteres 1 GB = CHF 15.-',

            'Single number':'Einzelnummer',
            'Number block 2-10':'Nummernblock 2-10',
            'Business Line > 10':'Business Line > 10',
            'Business Line TAG/GRA':'Business Line TAG/GRA',
            '058xxx numbers':'058XXX numbers',
            '08xx numbers':'08XX numbers',
            'Internat. Numbers':'Internat. Numbers',
            'Swiss phone number': 'Schweizer Rufnummer',


            /// MITEL HOSTED
            'presentatMitel': '<h2>Peoplefone MITEL HOSTED: die All-in-One-Lösung</h2>' +
              '<p>peoplefone MITEL HOSTED kann nur in Zusammenarbeit mit einem zertifizierten Mitel- Partner bestellt und installiert werden.</p>',
            'MIVO-OPI' : 'Hosting der Applikation MIVO400 OIP (CTI), ohne Lizenzen :',

            'abonnementMitel': 'Abonnement peoplefone MITEL HOSTED',
            'MIVO-hosted': 'Hosting der Basislösung MIVO400VA Hosted, ohne Lizenzen:',
            'machine-supp': '- 1 redundante virtuelle Maschine mit VPN <br>' +
              '- Inbetriebnahme und Wartung',
            'aboonementSupp': 'Zusätzliche Abonnemente',
            'MIVO-cloudLink': 'Hosting der Applikation MIVO400 CloudLink (Integration GSM / MoMa),\n' +
              'ohne Lizenzen:',
            'MIVO-telework': 'Hosting der Applikation MIVO400 MBG (Teleworker), ohne Lizenzen:',
            'capacite': 'Für eine Kapazität von:',
            'link_vpn': 'Zusätzliche VPN-Verbindungen für zusätzliche Standorte:',

            'up to 125 terminals': 'bis zu 125 Terminals',
            'up to 250 terminals': 'bis zu 250 Terminals',
            'up to 1250 terminals': 'bis zu 1250 Terminals',

            'up to 50 users': 'bis zu 50 Benutzer',
            'up to 300 users': 'bis zu 300 Benutzer',
            'up to 1200 users': 'bis zu 1200 Benutzer',

            /// NEW PHONE NUMBERS
            'TotalWishedNumbers': 'Total gewünschte Nummern',
            'OfferedNumbers': 'Offerierte Nummern',
            'NiceNumber': 'Spezialnummer',
            'Category': 'Kategorie',
            'SelectAllTheRangesOfNewPeoplefonePhoneNumbersHere': 'Wählen Sie hier die Nummernblöcke, die Sie neu bestellen möchten',
            'PriceOnDemand': 'Preis auf Anfrage',

            /// PEOPLEPHONE SIPTRUNK
            'setupCosts': 'Installationskosten',
            'unlimited': 'Unlimitiert',

            /// PEOPLEPHONE HOSTED
            // tslint:disable-next-line:max-line-length
            'SelectHereTheNumberOfUsersFaxAnsweringMachinesReserveOfUsersAndIVRNode': 'Wählen Sie hier die Anzahl Benutzer, Fax, Anrufbeantworter, Reserve, IVR etc, die Sie einrichten möchten',
            'Users': 'Benutzer',
            'NumbersOfUsersIPTerminals': 'Anzahl Benutzer (IP Soft-/Hardphones)',
            'NumberOfFaxToEmailRequiresUser': 'Anzahl Fax2Email (= Benutzer)',
            'NumberOfAnalogRequiresUser': 'Anzahl analoge Geräte* (= Benutzer)',
            'NumberOfCentralizedVoiceMailRequiresUser': 'Anzahl zentralisierte Anrufbeantworter (= Benutzer)',
            'ReserveOfUsers': 'Benutzer auf Reserve',
            'TotalOfTheSelectedUsers': 'Total ausgewählte Benutzer',
            'TotalOfAvailableUsersInTheProposedHOSTEDSolution': 'Total der verfügbaren Benutzer in der vorgeschlagenen HOSTED Lösung',
            'AllAnalogTerminalsRequiresCiscoSPA122Box': '* Alle analogen Geräte benötigen 1 VoIP-Adapter Cisco SPA 122',
            'NumberOfCiscoBoxWith2ConnectedAnalogsTerminals': 'Anzahl VoIP-Adapter Cisco mit 2 analogen Geräten',
            'NumberOfCiscoSPA122Box': 'Anzahl VoIP-Adapter Cisco SPA 122',
            'AddTheNumberOfCiscoSPA122BoxInTheShopPage': 'VoIP-Adapter Cisco SPA 122 im Shop hinzufügen',
            'PeoplephoneHostedIVR': 'peoplefone HOSTED IVR',
            'Nodes': 'Knoten',
            'NumberOfNodes': 'Anzahl Knoten',
            'PeoplephoneHostedSummary': 'peoplefone HOSTED Zusammenfassung',
            'TotalOfUsers': 'Anzahl Benutzer',
            'TotalOfIVRNodes': 'Anzahl IVR Knoten',
            'TotalMonthlyCosts': 'Total monatl. Kosten',

            'TotalUniqueCosts': 'Total unique costs',

            'PeoplephoneSoftphone': 'peoplefone SOFTPHONE',
            'PeoplephoneConnectorStandard': 'peoplefone CONNECTOR Standard',
            'PeoplephoneConnectorApi': 'peoplefone CONNECTOR API',

            'TotalOfSoftphone' : 'Anzahl peoplefone SOFTPHONE Benutzer',
            'TotalConnectorStandard' : 'Anzahl peoplefone CONNECTOR Standard Benutzer',
            'TotalConnectorApi' : 'Anzahl peoplefone CONNECTOR API Benutzer',

            'quantityuser' : 'Anzahl Benutzer',
            'AddPayingHosted' : 'Zusätzliche kostenpflichtige Funktionen',
            'adresseInput' : 'Installationsadresse ',

            /// FLAT RATE HOSTED
            // tslint:disable-next-line:max-line-length
            'SelectSubscriptionForBusinessFlatRatesForPeoplefoneHostedHere': 'Wählen Sie hier die Anzahl Flat für peoplefone HOSTED',
            'TheFlatRatesForPeopleFoneHostedAreDefinedPerUser': 'Die Anzahl Flat für peoplefone HOSTED ist pro Benutzer definiert',
            'users': 'Benutzer',
            // tslint:disable-next-line:max-line-length
            'TheNumberOfSelectedFlatRatesLimitsTheNumberOfOutgoingVoiceChannels': 'Die Anzahl Flat limitiert die Anzahl der ausgehenden Sprachkanäle.',
            'CanBeAdjustedAtAnyTime': 'Es kann jederzeit angepasst werden.',
            'TheNumbersOfSelectedFlatRatesUsers': 'Die Anzahl Flat-Benutzer limitiert nicht die Anzahl der eingehenden Sprachkanäle.',
            'DoesNotLimitTheNumberOfIncommingVC': 'Limitiert nicht die Anzahl der eingehenden Sprachkanäle.',
            // tslint:disable-next-line:max-line-length
            'TheMonthlyIncludedMinutesOfTheSubscriptionAreAvailableForEveryoneWithinTheAccount': 'De monatliche Minutenverbrauch wird für alle innerhalb des Kontos kumuliert.',
            // tslint:disable-next-line:max-line-length
            'TheMinimalContractPeriodForBusinessFlatRateIs12MonthsWithCancelationPeriodOf3Months': 'Die Mindestdauer der peoplefone Geschäft Flatrate ist 12 Monate mit einer 3-monatigen Kündigungsfrist',
            'TotalMinutes': 'Total Anzahl Minuten',
            'NetworkType': 'FLAT',
            'NbrOfUsers': 'Anzahl Benutzer',
            'FixNet': 'Festnetz',
            'MobileNet': 'Mobilnetz',
            'Channels': 'Kanäle',


            /// FLAT RATE SIP-TRUNK
            // tslint:disable-next-line:max-line-length
            'SelectSubscriptionForBusinessFlatRatesForPeoplefoneSIPTRUNKHere': 'Wählen Sie hier die Anzahl Flat für peoplefone SIP-TRUNK',
            'NbrOfVoiceChannels': 'Anzahl Sprachkanäle',

            'TheFlatRatesForPeopleFoneSIPTRUNKAreDefinedPerVC': 'Die Anzahl Flat für peoplefone SIP-TRUNK ist pro Sprachkanal definiert',
            // tslint:disable-next-line:max-line-length
            'TheNumberOfSelectedFlatRatesLimitsTheNumberOfOutgoingVC': 'Die Anzahl Flat limitiert die Anzahl der ausgehenden Sprachkanäle.',
            'VC': 'Sprachkanäle',
            'TheNumbersOfSelectedFlatRatesVC': 'Die Anzahl Flat-Sprachkanäle limitiert nicht die Anzahl der eingehenden Sprachkanäle.',



            /// POEPLEFONE DEVICES DATA BASE
            'MyBag': 'Mein Warenkorb',
            'PeoplefoneDevicesDataBase': 'peoplefone Produkte Datenbank',
            'Pos': 'Pos.',
            'Qty': 'Menge',
            'TotalIntermediary': 'Zwischentotal',
            'ShippingCost': 'Versandkosten',
            'Discount': 'Rabatt',
            'TotalWithoutTaxes': 'Total exkl. MwSt.',
            'Taxes7': 'MwSt.',
            'TotalWithTaxes': 'Total inkl. MwSt.',
            'ContinueShopping': 'Weiter shopping',
            'GoToProjectSummary': 'Weiter zur Offerten Zusammenfassung',
            'DeskTelephone': 'Tischtelefone',
            'CordlessTelephone': 'Kabellose Telefone',
            'VoIPAdapters': 'VoIP-Adapter',
            'PCApp': 'PC App/Smartphone APP',
            'Accessories': 'Zubehör',
            'Router/Firewall/Switch': 'Router / Firewall / Switch',
            'MyArticles': 'Meine Produkte',
            'DeviceAddedToBag': 'Produkt wurde dem Warenkorb hinzugefügt',
            'DeviceAddedToMyDevices': 'Produkt wurde bei Meine Produkte hinzugefügt',


            // MY DEVICES
            'AddNewArticles': 'Neues Produkt hinzufügen',
            'AddNewArticle': 'Neues Produkt hinzufügen',
            'SaveAddNextArticle': 'Speichern und nächstes Produkt hinzufügen',
            'Back': 'Zurück zur Liste',


            // OFFER SUMMARY
            'Model': 'Modell',
            'Details': 'Details',
            'Bandwidths/IPaddress': 'Bandbreite/IP Adressen',
            'Total': 'Total',
            'SLA24/24': 'SLA',
            'PortedPhoneNumbers': 'Portierte Telefonnummern',
            'Numbers': 'Nummern',
            'UsersNodes': 'Benutzer / Knoten',
            'CostsOfPP': 'peoplefone Dienstleistungen/Produkte',
            'TotalCostsOfPP': 'Total peoplefone Dienstleistungen und Produkte',
            'TotalMaterialsOfPP': 'Total Dienstleistungen und Produkte des Partners',
            'DiscountMaterialsOfPP': 'Rabatte der Dienstleistungen und Produkte des Partners',
            'TotalDiscount': 'Total Rabatte (Einmalige Kosten)',
            'TotalMaterialsOfPPDiscount': 'Total Dienstleistungen und Produkte des Partners (inkl. Rabatte)',
            'PPDevicesDataBase': 'Ergänzende Dienstleistungen/Produkte',
            'NiceNumbers': 'Spezialnummern',
            'OfferConditionsText': '<b>Dies ist lediglich eine Offerte.<br />' +
              'Bei Projektgewinn müssen die entsprechenden peoplefone Verträge separat unterschrieben und an peoplefone gesendet werden.</b>',
            'OfferConditionsLabel': 'Ich habe den Unterschied zwischen Offerte und Vertrag verstanden.',
            'exportHasNoVATLabel': 'Exportieren Sie das Angebot ohne Mehrwertsteuer',


            // MANAGEMENT
            'ManagementPeoplefoneDevicesDataBase': 'Verwaltung der peoplefone Produkte',

            // MANAGEMENT MY DEVICES
            'ManagementMyDevicesDataBase': 'Verwaltung von "Meine Produkte"',

            // SUMMARY
            'CostsSummary': 'Zusammenfassung Kosten',
            'TotalOfMonthlyCosts(VAT)': 'Total monatl. Kosten (inkl. MwSt.)',
            'TotalOfUniqueCosts(VAT)': 'Total von einmal. Kosten (inkl. MwSt.)',
            'TotalCosts(VATincluded)': 'Total Kosten (inkl. MwSt.)',
            'VATAcronym': 'MwSt.',

            // EDIT DEVICES
            'Image': 'Bild',
            'Link': 'Link',
            'TitleDescription': 'Titel und Beschreibung',
            'PurchasePrice': 'Einkaufspreis',
            'SalesPrice': 'Verkaufspreis',
            'DeviceSaved': 'Produkt wurde gespeichert',
            'PleaseProvideProperPriceValue': 'Bitte geben Sie den korrekten Preis an !',

            // Peoplefone Bundle
            'BundleHeadline': 'peoplefone BUNDLE',
            'BundleType': 'Abonnement',
            'BundleOptions': 'Optionen',
            'BundleInternetProvider': 'Internet Anbieter',
            'BundleAddon': 'Erweiterung',
            'BundlePortedNumbers': 'Nummernportierung',
            'BundlePortedNumbersNone': 'Keine Portierung',
            'BundlePortedNumbersMSN': 'Multi Line',
            'BundlePortedNumbersDDI': 'Business Line',
            'BundleRouterText': 'Der Internet-Router ist nicht im peoplefone BUNDLE inbegriffen und ' +
              'muss separat bestellt werden. Sie finden unsere Router-Optionen unter ' +
              '«peoplefone Produkte». Sie können auch unter «Meine Produkte» weitere Routers addieren.',
            'BundleIPWorldcom': 'IP Worldcom',
            'BundleCyberlink': 'Cyberlink',
            'BundleRouter': 'Router',
            'No router': 'Kein Router',

            // Peolefone Microsoft Teams
            'TeamsHeadline': 'peoplefone MICROSOFT TEAMS Direct Routing',
            'OperatorConnectHeadline': 'peoplefone MICROSOFT TEAMS Operator Connect',
            'SBCplusHeadline': 'peoplefone MICROSOFT TEAMS SBCplus',
            'TeamsAmount': 'Anzahl',
            'TeamsUsers': 'Sprachkanäle (min. 2)',
            'TeamsSetup': 'peoplefone MICROSOFT TEAMS Set-Up',
            'TeamsSetupDesc': 'Erstmalige Einrichtung',

            // Peoplefone 3CX
            '3cx': '3CX',
            '3cxHeadline': 'peoplefone 3CX HOSTED',
            '3cxOptions': 'Optionen',
            '3cxType': 'Edition',
            '3cxTypeUnlicensed': 'Ohne Lizenz',
            '3cxTypeStandard': 'Standard - nicht mehr verfügbar',
            '3cxTypeProfessional': 'Professional',
            '3cxTypeEnterprise': 'Enterprise',

            '3cxUnlicensed8' : 'Standard',
            '3cxUnlicensed16' : 'Medium',
            '3cxUnlicensed96' : 'Large',
            '3cxUnlicensed512' : 'Enterprise',

            '3cxTerm': 'Mindestvertragslaufzeit',
            '3cxTerm12': '12 Monate',
            '3cxTerm24': '24 Monate',
            '3cxSC': 'SC / Variant',
            '3cxSCs': 'SC',
            '3cxAddon': 'Erweiterung',
            '3cxAddonStorage': 'Zusätzlicher Speicherplatz',
            '3cxAddonStorageNone': 'None',
            '3cxAddonStorageExtension64': '64 GB',
            '3cxAddonStorageExtension96': '96 GB',
            '3cxAddonStorageExtension128': '128 GB',
            '3cxSummary': 'Zusammenfassung',
            '3cxMonths': 'Monate',

            // peoplefone Internet
            'DSL/FIBER' : 'peoplefone Internet (DSL/FIBER)',

             //peoplefone MOBILE
             'MobileHeadline' : 'peoplefone MOBILE',
             'MobileSubscription' : 'Abonnement',
             'Extra Cards' : 'Zusatzkarten',
             'Extra Cards Data' : 'Zusatzkarten (Data)',
             'Extra Cards Watch' : 'Zusatzkarten (Uhr)'

          });
      }

      case 'fr': {
        return Observable.of(
          {
            'promo-bundle-hosted-internet':'PROMO peoplefone BUNDLE : Si vous commandez peoplefone HOSTED et peoplefone INTERNET en même temps, vous pouvez cocher cette case et obtenir le produit peoplefone SOFTPHONE gratuitement pour une durée de 12 mois.',
            'uitext.offer.nda' : 'peoplefone met les offres établies à la disposition du partenaire sous forme de fichier Word. Ces fichiers peuvent être retravaillés par le partenaire. peoplefone ne garantit pas l\'exactitude des fichiers Word lors du traitement ultérieur et ne peut pas être tenu responsable en cas de modifications éventuelles des prix, des rabais ou d\'autres données similaires.',
            'uitext.yes' : 'Oui',
            'uitext.no' : 'Non',
            'uitext.offer.options.datasim.voice-option': 'Option VOICE',
            'uitext.offer.options.datasim.desc':
            'peoplefone DATASIM offre un accès illimité à l\'Internet mobile pour toutes sortes d\'appareils intelligents, tels que<br>les ordinateurs portables, les tablettes, les routeurs LTE, les trackers GPS, les capteurs, les smartwatches, les télécommandes,<br>les caméras de surveillance LTE ou les hotspots mobiles.'+
            '<br><br>En outre, vos clients peuvent utiliser leur téléphone portable avec la peoplefone DATASIM<br>pour téléphoner via leur numéro professionnel peoplefone.'+
            '<br><br>Vous trouverez plus \'informations à l\'adresse suivante <a target="_blank" href="https://www.peoplefone.com/fr-ch/clients/produits/internet/peoplefone-datasim">https://www.peoplefone.com/fr-ch/clients/produits/internet/peoplefone-datasim</a>',

            'uitext.offer.options.my-devices.desc': '<p>Dans &laquo;&nbsp;Mes appareils&nbsp;&raquo; peuvent &ecirc;tre ' +
                'm&eacute;moris&eacute;s tous les terminaux t&eacute;l&eacute;phoniques, adaptateurs VoIP, &eacute;l&eacute;ments' +
                ' actifs du r&eacute;seau informatiques, c&acirc;bles et autres produits et services que le partenaire propose' +
                ' r&eacute;guli&egrave;rement &agrave; ses clients.<br />Chaque &eacute;l&eacute;ment peut &ecirc;tre modifi&eacute; ' +
                'et son prix adapt&eacute; selon besoin, et de nouveaux &eacute;l&eacute;ments peuvent y &ecirc;tre ajout&eacute;s,' +
                ' &agrave; partir de l&rsquo;onglet &laquo;&nbsp;gestion des bases de donn&eacute;es&nbsp;&raquo;.</p>',

            'uitext.offer.options.biz-flrat-hosted.desc': '<p>Grâce à peoplefone FLAT vous téléphonez à des tarifs forfaitaires attractifs en Suisse et en Europe.</p>\n' +
              '<br><p>Le paquet FLAT approprié peut être commandé en fonction de votre comportement d\'appel individuel.</p>'+
              '<br><p>"Hosted FLAT CH" pour peoplefone HOSTED<br>"Hosted FLAT CH/EU" pour peoplefone HOSTED</p>'+
              '<br><p>Vous trouverez les offres détaillées et les conditions sous :<br>' +
              '<a target="_blank" href="https://www.peoplefone.com/fr-ch/clients/tarifs-numeros/tarifs-offres/peoplefone-flat">https://www.peoplefone.com/fr-ch/clients/tarifs-numeros/tarifs-offres/peoplefone-flat</a></p>',

            'uitext.offer.options.new-numbers.desc': '<p>peoplefone propose diff&eacute;rents types de num&eacute;ros de ' +
                't&eacute;l&eacute;phone: Num&eacute;ros suisses avec tous les indicatifs nationaux, num&eacute;ros commerciaux 058,' +
                ' num&eacute;ros internationaux (50 pays), ainsi que de jolis num&eacute;ros selon 4 classes de tarification ' +
                '(co&ucirc;ts uniques).<br />Le tarif des num&eacute;ros internationaux d&eacute;pend du pays souhait&eacute; ' +
                '(voir notre site Internet) - Le prix de location des num&eacute;ros doit &ecirc;tre introduit dans' +
                ' l&rsquo;aper&ccedil;u de l&rsquo;offre.<br /> S&eacute;lectionner le type de num&eacute;ros, le nombre de' +
                ' num&eacute;ros et le nombre de joli num&eacute;ro (num&eacute;ros sp&eacute;ciaux) si souhait&eacute;. ' +
                'S&eacute;lectionner une plage suppl&eacute;mentaire si n&eacute;cessaire.</p>',

            'uitext.offer.options.internet-ipworldcom.desc': '<p>En collaboration avec notre partenaire <strong>IP worldcom</strong>' +
                ',nous vous fournissons des connexions Internet professionnelles de technologies DSL et fibre optique en fonction de' +
                ' l&rsquo;emplacement de votre futur client. <br /> Avant de faire votre choix parmi les diff&eacute;rents profils et' +
                ' technologies propos&eacute;s, veuillez v&eacute;rifier la technologie et la vitesse disponible &agrave; ' +
                'l&rsquo;adresse de votre futur client.</p>\n',

            'uitext.offer.options.pf-devices.desc': '<p>peoplefone propose ici une s&eacute;lection de produits VoIP recommand&eacute;s' +
                ' pouvant &ecirc;tre ajout&eacute;s dans l&rsquo;offre du client.<br /> Chaque appareil peut &ecirc;tre import&eacute; ' +
                'dans &laquo;&nbsp;Mes appareils&nbsp;&raquo; en s&eacute;lectionnant l&rsquo;&eacute;toile. Le descriptif et le prix de' +
                ' chaque appareil peuvent &ecirc;tre ensuite adapt&eacute;s aux besoins de chaque partenaire.</p>',

            'uitext.offer.options.biz-flrat-siptrunk.desc': '<p>Grâce à peoplefone FLAT vous téléphonez à des tarifs forfaitaires attractifs en Suisse et en Europe.</p>\n' +
              '<br><p>Le paquet FLAT approprié peut être commandé en fonction de votre comportement d\'appel individuel.</p>\n' +
              '<br><p>"SIP FLAT CH" pour les produits SIP-TRUNK<br>"SIP FLAT CH/EU" pour les produits SIP-TRUNK</p>'+
              '<br><p>Vous trouverez les offres détaillées et les conditions sous :<br>' +
              '<a target="_blank" href="https://www.peoplefone.com/fr-ch/clients/tarifs-numeros/tarifs-offres/peoplefone-flat">https://www.peoplefone.com/fr-ch/clients/tarifs-numeros/tarifs-offres/peoplefone-flat</a></p>',

            'uitext.offer.options.disclaimer.desc': '<p><strong>Informations g&eacute;n&eacute;rales</strong><br />' +
                'Avec cet outil d&rsquo;offres vous pouvez configurer une' +
                ' nouvelle offre peoplefone. Vous pouvez par la suite la modifier, la dupliquer, puis l&rsquo;imprimer en fichier .docx.' +
                '<br />L&rsquo;outil permet &eacute;galement le suivi d&rsquo;offres, afin de ne pas perdre de vue vos nombreux projets.' +
                '</p><p><strong>IMPORTANT: limitation de responsabilit&eacute;</strong><br />peoplefone a d&eacute;velopp&eacute; et ' +
                'test&eacute; cet outil d&rsquo;offres avec la plus grande pr&eacute;caution. L\'emploi de cet outil d&rsquo;offre ne' +
                ' dispense pas son utilisateur de v&eacute;rifier, avec tout le soin requis, l\'ad&eacute;quation entre les besoins des ' +
                'clients et les solutions propos&eacute;es.<br />peoplefone n\'assume aucune responsabilit&eacute; quant aux solutions ' +
                'cr&eacute;&eacute;es avec cet outil d&rsquo;offre, quant &agrave; leur ad&eacute;quation avec les besoins des clients.' +
                ' La responsabilit&eacute; de peoplefone pour d\'&eacute;ventuels dommages indirects r&eacute;sultant de l\'emploi du ' +
                'pr&eacute;sent outil d&rsquo;offres (tels que, par exemple, la perte de gain, de contrat ou de chiffre d\'affaires) est ' +
                'exclue.<br />Veuillez noter que les devis issus du peoplefone offer tool ne constituent pas un contrat entre vous/votre ' +
                'client et peoplefone.</p><p>Des informations plus amples et les &ldquo;Conditions g&eacute;n&eacute;rales&rdquo; de ' +
                'peoplefone SA se trouvent en ligne sur <a target="_blank" href="https://www.peoplefone.ch">www.peoplefone.ch</a> en ' +
                'tout temps.</p>\n',

            'uitext.offer.options.pf-hosted.desc': '<p>peoplefone HOSTED est un central t&eacute;l&eacute;phonique virtuel ' +
                'h&eacute;berg&eacute; chez peoplefone. Il remplace les &eacute;quipements de communication traditionnels (PBX).<br />' +
                'Afin de pr&eacute;voir le nombre total d&rsquo;utilisateurs de la solution HOSTED, introduire le nombre de terminaux IP,' +
                ' le nombre de fax2email, le nombre de terminaux analogiques (inclus fax analogique), le nombre de r&eacute;pondeurs ' +
                'centralis&eacute;s (Voice mail personnel exclus), une r&eacute;serve &eacute;ventuelle. Si une solution IVR est ' +
                'souhait&eacute;e (t&eacute;l&eacute;phoniste automatique), introduire le nombre de noeux n&eacute;cessaire.' +
                ' Les fonctions payantes supplémentaires de peoplefone HOSTED IVR, peoplefone SOFTPHONE et peoplefone CONNECTOR peuvent également être calculées dans l\'offre.</p>',

            'uitext.offer.options.ported-numbers.desc': '<p>peoplefone propose diff&eacute;rents type de num&eacute;ros de ' +
                't&eacute;l&eacute;phone: Num&eacute;ros suisses avec tous les indicatifs nationaux, num&eacute;ros commerciaux 058, ' +
                'num&eacute;ros internationaux (50 pays), ainsi que de jolis num&eacute;ros selon 4 classes de tarification.<br />' +
                'Le tarif des num&eacute;ros internationaux d&eacute;pend du pays souhait&eacute; (voir notre site Internet) - Le prix de' +
                ' location du num&eacute;ro doit &ecirc;tre introduit dans l&rsquo;aper&ccedil;u de l&rsquo;offre.<br />' +
                'S&eacute;lectionner le type de num&eacute;ros, le nombre de num&eacute;ros et le nombre de jolis num&eacute;ro ' +
                '(num&eacute;ros sp&eacute;ciaux) si souhait&eacute;.<br /> S&eacute;lectionner une plage suppl&eacute;mentaire de ' +
                'num&eacute;ros si n&eacute;cessaire.</p>\n',

            'uitext.offer.options.internet-cyberlink.desc': '<p>peoplefone INTERNET est une connexion Internet librement configurable avec ou sans services gérés, dans le réseau FIBER ou DSL.</p>\n' +
              '<br>\n' +
              '<p>Nous proposons les services suivants :</p>\n' +
              '<ul><li>Offre Internet S</li>\n' +
              '<li>Offre Internet M</li>\n' +
              '<li>Offre Internet L</li>\n' +
              '<li>Offre Internet avec Managed Services</li></ul>\n' +
              '<br>\n' +
              '<p>Les détails, ainsi que toutes les options possibles, sont disponibles à l\'adresse suivante <a target="_blank" href="https://www.peoplefone.com/fr-ch/clients/produits/internet/peoplefone-internet">https://www.peoplefone.com/fr-ch/clients/produits/internet/peoplefone-internet</a></p>\n',

            'uitext.offer.options.pf-siptrunk.desc': '<p>peoplefone SIP-TRUNK est la ligne VoIP pour tout type d\'installation téléphonique et est certifiée par la grande majorité des fabricants d\'installations téléphoniques.</p> \n' +
              '<br><p>Les avantages de peoplefone SIP-TRUNK :</p>\n' +
              '<ul><li>Opérationnel en quelques minutes</li>\n' +
              '<li>Nombre illimité de canaux vocaux gratuits</li>\n' +
              '<li>Essai gratuit sans engagement pendant 30 jours, y compris numéros de téléphone et crédit d\'essai</li>\n' +
              '<li>Coût de la communication par minute ou en modèle FLAT</li>\n' +
              '<li>Possible sans engagement contractuel avec Pre-Paid</li></ul>\n' +
              '<br><p>Vous trouverez plus d\'informations sur <a target="_blank" href="https://www.peoplefone.com/fr-ch/clients/produits/telephonie/peoplefone-sip-trunk">https://www.peoplefone.com/fr-ch/clients/produits/telephonie/peoplefone-sip-trunk</a></p>',


            'uitext.offer.options.pf-3cx.desc': '<p>Avec peoplefone 3CX HOSTED, vous passez à un système de communication IP plus flexible et plus économique, qui convainc par une gamme impressionnante de performances UCC !</p>\n' +
              '<p>L\'offre est disponible en 3 options.</p>\n' +
              '<p>Professional et Enterprise de 4 à 128 SC.</p>\n' +
              '<p>Pour les partenaires 3CX, une 3CX sans licence en 4 variantes de Standard à Enterprise (hébergement uniquement).</p>\n' +
              '<br><p>Vous trouverez les spécifications exactes de peoplefone 3CX HOSTED ici : <a target="_blank" href="https://www.peoplefone.com/fr-ch/clients/produits/telephonie/peoplefone-3cx-hosted">https://www.peoplefone.com/fr-ch/clients/produits/telephonie/peoplefone-3cx-hosted</a>.</p>',

            'uitext.offer.options.teams.desc': '<p>Microsoft TEAMS est une solution de collaboration intégrée à Microsoft 365, qui ' +
              'grâce à la solution « peoplefone MICROSOFT TEAMS », peut être raccordée au réseau téléphonique public de peoplefone.  <br>' +
              'Les coûts de peoplefone MICROSOFT TEAMS sont dépendants du nombre d’appels simultanés désirés. ' +
              'Un abonnement de peoplefone MICROSOFT TEAMS peut être conclu pour un minimum de ' +
              '2 canaux vocaux et pour une période minimum de 12 mois.</p>'+
              '<p>Vous trouverez plus d\'informations à l\'adresse suivante <a target="_blank" href="https://www.peoplefone.com/fr-ch/clients/produits/telephonie/peoplefone-microsoft-teams">https://www.peoplefone.com/fr-ch/clients/produits/telephonie/peoplefone-microsoft-teams</a></p>',

            'uitext.offer.options.operator-connect.desc': '<p>Intégration directe dans l\'univers Microsoft<br>En sélectionnant peoplefone comme fournisseur dans votre compte Microsoft 365.</p>'+
              '<ul><li>Avec peoplefone OPERATOR CONNECT pour Microsoft Teams vous connectez directement TEAMS au réseau VoIP de peoplefone.</li>'+
              '<li>Installation initiale par peoplefone</li>' +
              '<li>Support par votre installateur IT local</li>'+
              '<li>Abonnement par utilisateur</li></ul>'+
              '<p>Vous trouverez plus d\'informations à l\'adresse suivante <a target="_blank" href="https://www.peoplefone.com/fr-ch/clients/produits/telephonie/peoplefone-microsoft-teams">https://www.peoplefone.com/fr-ch/clients/produits/telephonie/peoplefone-microsoft-teams</a></p>',

              'uitext.offer.options.sbcplus.desc' : '<p>Une solution 100% individualisée pour chaque entreprise <br> SBCplus - la connexion dédiée de la téléphonie à TEAMS</p>'+
              '<ul><li>Propre contrôleur de session en périphérie</li>'+
              '<li>Hébergement local</li>'+
              '<li>Phase d\'intégration "intelligente"</li>'+
              '<li>Connexion de toutes les solutions tierces imaginables (par exemple PBX, centre de contact ou serveur d\'alarme).</li>'+
              '<li>Toute personnalisation supplémentaire telle que des ateliers d\'intégration ou des accords de niveau de service.</li></ul>'+
              '<p>Vous trouverez plus d\'informations à l\'adresse suivante <a target="_blank" href="https://www.peoplefone.com/fr-ch/clients/produits/telephonie/peoplefone-microsoft-teams">https://www.peoplefone.com/fr-ch/clients/produits/telephonie/peoplefone-microsoft-teams</a></p>',

            'uitext.offer.options.pf-bundle.desc': '<p>peoplefone est une offre combinée avantageuse. Vous téléphonez avec peoplefone HOSTED, le système téléphonique performant de peoplefone, et utilisez l\'offre INTERNET de peoplefone à différents niveaux de prestations.</p>\n' +
              '<br><p>Peoplefone BUNDLE existe en 4 packs :</p>\n' +
              '<ul><li>BASIC BUSINESS PACK</li>\n' +
              '<li>ADVANCED BUSINESS PACK</li>\n' +
              '<li>FULL BUSINESS PACK</li>\n' +
              '<li>PROFESSIONAL BUSINESS PACK</li></ul>\n' +
              '<br><p>Vous trouverez les spécifications exactes de peoplefone BUNDLE ici : <a target="_blank" href="https://www.peoplefone.com/fr-ch/clients/tarifs-numeros/tarifs-offres/peoplefone-bundle">https://www.peoplefone.com/fr-ch/clients/tarifs-numeros/tarifs-offres/peoplefone-bundle</a></p> ',

              'uitext.offer.options.mobile.desc': '<p>peoplefone MOBILE propose des abonnements mobiles attrayants pour la Suisse et pour l\'utilisation internationale.</p>\n' +
              '<br><p>Pour chaque abonnement, il est possible de commander jusqu\'à 4 Xtra-Cards (pour les ordinateurs portables, les tablettes et les montres intelligentes). Avec tous les abonnements, on peut toujours se déplacer à pleine vitesse sur le réseau 5G de Sunrise.</p>\n' +

              '<br><p>Vous trouverez de plus amples informations sur <a target="_blank" href="https://www.peoplefone.com/fr-ch/clients/produits/telephonie/peoplefone-mobile">https://www.peoplefone.com/fr-ch/clients/produits/telephonie/peoplefone-mobile</a></p>',

            /// DISCLAIMER
            'GeneralInformationAndLimitOfResponsibility': 'Bienvenue au peoplefone Offer Tool',

            /// LOGIN
            'WelcomePeoplefoneSalesTool': 'Bienvenue au peoplefone Offer Tool',
            'AccessAccount': 'Accès à votre compte',
            'LoginID': 'Login ID',
            'EnterReselerID': 'Entrer votre nom d\'utilisateur peoplefone',
            'Password': 'Mot de passed',
            'EnterReselerPW': 'Entrer votre mot de passe',
            'LOGIN': 'LOGIN',


            /// TOP BAR
            'Logout': 'Logout',


            /// SIDE BAR
            'AllOffers': 'Toutes les offres',
            'FollowUp': 'Suivi de l\'offre',
            'Business': 'peoplefone FLAT',
            'BusinessFlatRates': 'Forfaits Business',
            'OfferSummary': 'Aperçu des offres',
            'Management': 'Gestion',
            'Previous': 'Précédent',
            'Next': 'Prochain',
            'NewOffer': 'Nouvelle offre',
            'ManagementOfTheDataBases': 'Bases de données / Paramètres',
            'ManagementOfPPDB': 'Gestion de la base de donnée de peoplefone',
            'ManagementOfMyDevices': 'Gestion de la base de donnée de "Mes appareils"',
            'Settings': 'Paramètres',
            'LogoToShow': 'Logo à afficher sur les offres (128x128)',
            'ClickToBrowse': 'Cliquez pour choisir une image',

            /// MY OFFER COMPONENT
            'MyOffers': 'Mes offres',
            'Overview': 'Aperçu',
            'OverviewStatus': 'Aperçu du statut',
            'People': 'Personne de contact du partenaire',
            'Period': 'Période',
            'ALL': 'Toutes',
            'LastYear': 'Année passée',
            'CurrentYear': 'Année actuelle',
            'ALLOffers': 'Toutes les offres',
            'OPENOffers': 'Offres ouvertes',
            'WONOffers': 'Offres gagnées',
            'LOSTOffers': 'Offres perdues',
            'ANY': 'Toutes',
            'MonthlyCostRealized': 'Coûts mensuels réalisés',
            'UniqueCostRealized': 'Coûts uniques réalisés',
            'PotentialMonthlyCost': 'Coûts mensuels potentiels',
            'PotentialUniqueCost': 'Coûts uniques potentiels',
            'AddNewOffer': 'Ajouter une nouvelle offre',
            'SearchOffers': 'Recherche d\'offre',
            'OfferStatus': 'Statut de l\'offre',
            'OfferNumber': 'Numéro d\'offre',
            'OfferID': 'ID de l\'offre',
            'CompanyName': 'Nom d\'entreprise',
            'ContactPerson': 'Personne de contact',
            'PostalCode': 'Code postale',
            'City': 'Ville',
            'PhoneNumber': 'Numéro de téléphone',
            'MobileNumber': 'Numéro de portable',
            'SalesStage': 'Phase de vente',
            'NextStep': 'Prochaine étape',
            'DateFrom': 'Date - de',
            'DateTill': 'Date - jusqu\'à',
            'Search': 'Recherche',
            'Cancel': 'Effacer',
            'Reset': 'Revenir en arrière',
            'SelectedOffers': 'Offres sélectionnées',
            'No': 'Numéro',
            'OfferNr': 'No. d\'offre',
            'DateIN': 'Date d\'entrée',
            'Customer': 'Client',
            'FollowUP': 'Suivi',
            'Edit': 'Modifier',
            'Save': 'Sauver',
            'Duplicate': 'Copier',
            'Delete': 'Effacer',
            'PrintOffer': 'Imprimer l\'offre',
            'ExportDocFile': 'Exporter le fichier .doc',
            'NOOFFERRECORDFOUND': 'Aucune offre trouvée',
            'Solution' : 'Solution',
            /// FOLLOW UP COMPONENT
            'OfferFollowUp': 'Suivi de l\'offre',
            'Description': 'Description',
            'Date': 'Date',
            'Contact': 'Contact',
            'Visit': 'Visite',
            'SendOffer': 'Envoyer l\'offre',
            'WaitingFeedback': 'Attendre la réponse',
            'ReminderNextDate': 'Rappel de la prochaine date',
            'AddFollowUp': 'Ajouter un suivi',
            'EditOffer': 'Modifier l\'offre',
            'DeleteOffer': 'Effacer l\'offre',
            'NoIpAdresse':'1 adresse IP dynamique',

            /// CUSTOMER PROFILE
            'CustomerProfile': 'Profil du client',
            'Company': 'La firme',
            'FirstName': 'Prénom',
            'LastName': 'Nom',
            'Position': 'Position',
            'EmailAddress': 'E-mail',
            'LanguagePost': 'Langue de correspondance',
            'SelectLanguage': 'Sélectionner la langue',
            'Offer': 'Offre',
            'AddContactPerson': 'Ajouter une personne de contact',
            'Update': 'Mettre à jour',


            /// SELECT WISHED SOLUTION
            'SelectTheWishedSolution': 'Sélectionner les options d\'offre',
            'PeoplephoneInternetIPworldcom': 'peoplefone Internet IP Worldcom',
            'PeoplephoneInternetCyberlink': 'peoplefone INTERNET',
            'PhoneNumbersToBePorted': 'Portage de numéro de téléphone',
            'NewPhoneNumbers': 'Nouveaux numéros de téléphone',
            'PeoplephoneSIPTRUNK': 'peoplefone SIP-TRUNK',
            'PeoplephoneHosted': 'peoplefone HOSTED',
            'FlatRateHOSTED': 'HOSTED',
            'FlatRateSIPTRUNK': 'SIP-TRUNK',
            'PeoplephoneDevicesDataBase': 'Appareils peoplefone',
            'MyDevicesDataBase': 'Mes appareils',
            '3CX': '3CX',
            'MicrosoftTeams': 'Microsoft Teams',

            'end-to-end' : 'End-to-End QoS',
            'dsl-connection' : 'Mise à niveau pour la connexion DSL',
            'sim-card' : 'Carte SIM avec 2 GB de données*',
            'add-GB' : '*Si le volume mensuel est épuisé, 1 GB supplémentaire est automatiquement activé. Pour chaque 1 GB de données supplémentaire = CHF 15.-',

            /// PEOPLEPHONE IPworldcom
            'MyOffer': 'Mon offre',
            'Technology': 'Technologie',
            'Bandwidths': 'Bande passante',
            'IPaddress': 'Adresses IP',
            'MonthlyCosts': 'Coûts mensuels',
            'UniqueCosts': 'Coûts uniques',
            'Internet': 'Internet',
            'Asymmetric': 'Asymétriques',
            'Symmetric': 'Symétriques',
            'SupportTime': 'Temps de support',
            'TypeOfRouter': 'Type de routeur',
            'AddInternetConnection': 'Ajouter une connection internet',
            'IPaddressIsIncluded': 'La première adresse IP fixe est incluse dans le prix de chaque connection',

            'SLA Unmanaged Basic':  'SLA Unmanaged Basic',
            'SLA Managed Basic reactif': 'SLA Managed Basic réactif',
            'SLA Managed Standard proactif': 'SLA Managed Standard proactif',
            'SLA Managed Premium proactif': 'SLA Managed Premium proactif',

            'Select Router': 'Select Router',
            'Zyxel XMG 3927 G-Fast with WLAN': 'Zyxel XMG 3927 g.Fast with WLAN',
            'Zyxel XMG3927 G-fast Bridge': 'Zyxel XMG3927 G-fast Bridge',
            'Media-Converter CVT3112W2A': 'Media-Converter CVT3112W2A',
            'Zyxel XMG3927 G-fast WLAN PRECONFIGURE': 'Zyxel XMG3927 G-fast WLAN PRECONFIGURE',
            'CTS FTTH-Gateway VRG5-31412 Passerelle fibre WLAN': 'CTS FTTH-Gateway VRG5-31412 Passerelle fibre WLAN',
            'CTS FTTH-Gateway VRG5-31412 Passerelle fibre WLAN PRECONFIGURE': 'CTS FTTH-Gateway VRG5-31412 Passerelle fibre WLAN PRECONFIGURE',

            /// PHONE NUMBERS TO BE PORTED
            // tslint:disable-next-line:max-line-length
            'SelectHereAllTheRangesOfNumbersToBePortedByPeoplephone': 'Sélectionner ici toutes les plages de numéros à porter par peoplefone',
            'ConnectionType': 'Type de numéro',
            'totalCount': 'Nombre total de numéros de téléphone',
            'Range': 'Plage',
            'EconomyLine': 'Economy Line',
            'MultiLine': 'Multi Line',
            'BusinessLineDDI': 'Business Line - DDI',
            'SCBusinessLineGRA': 'Business Line GRA',
            'InternatNumbers': 'Numéros internat.',
            'AddNewRange': 'Ajouter un nouveau plage de no.',

            'Single number': 'Numéro individuel',
            'Number block 2-10': 'Bloc de numéro non linéaire',
            'Business Line > 10': 'Business Line > 10',
            'Business Line TAG/GRA': 'Business Line TAG/GRA',
            '058xxx numbers': 'Numéros 058XXX',
            '08xx numbers': 'Numéros 08XX',
            'Internat. numbers': 'Numéros internat.',
            'Swiss phone number': 'Numéros Suisse',

            /// NEW PHONE NUMBERS
            'TotalWishedNumbers': 'Nombre de numéros souhaités',
            'OfferedNumbers': 'Numéros offerts',
            'NiceNumber': 'Numéros spéciaux',
            'Category': 'Catégorie',
            'SelectAllTheRangesOfNewPeoplefonePhoneNumbersHere': 'Sélectionner toutes les plages de nouveaux numéros peoplefone',
            'PriceOnDemand': 'Prix sur demande',

            /// PEOPLEPHONE SIPTRUNK
            'setupCosts': 'Coûts d’installation',
            'unlimited': 'Illimité',


            /// PEOPLEPHONE HOSTED
            // tslint:disable-next-line:max-line-length
            'SelectHereTheNumberOfUsersFaxAnsweringMachinesReserveOfUsersAndIVRNode': 'Sélectionner le nombre d\'utilisateurs, fax, répondeurs, réserve d\'utilisateurs et nœud IVR',
            'Users': 'Utilisateurs',
            'NumbersOfUsersIPTerminals': 'Nombre d\'utilisateurs (terminaux IP)',
            'NumberOfFaxToEmailRequiresUser': 'Nombre de fax to email (nécessite 1 utilisateur)',
            'NumberOfAnalogRequiresUser': 'Nombre d\'appareils analogiques (nécessite 1 utilisateur)',
            'NumberOfCentralizedVoiceMailRequiresUser': 'Nombre de répondeur centralisé (nécessite 1 utilisateur)',
            'ReserveOfUsers': 'Réserve d\'utilisateurs',
            'TotalOfTheSelectedUsers': 'Total des utilisateurs sélectionnés',
            'TotalOfAvailableUsersInTheProposedHOSTEDSolution': 'Total des utilisateurs disponibles dans la solution HOSTED proposée',
            'AllAnalogTerminalsRequiresCiscoSPA122Box': 'Tous les terminaux analogiques nécessitent 1 boîtier Cisco SPA122',
            'NumberOfCiscoBoxWith2ConnectedAnalogsTerminals': 'Nombre de boîtier Cisco avec 2 bornes analogiques connectées',
            'NumberOfCiscoSPA122Box': 'Nombre d\'adaptateurs VoIP Cisco SPA 122',
            'AddTheNumberOfCiscoSPA122BoxInTheShopPage': '(ajouter le nombre de boîtier Cisco SPA 122 dans la page du shop)',
            'PeoplephoneHostedIVR': 'peoplefone HOSTED IVR',
            'Nodes': 'Noeuds',
            'NumberOfNodes': 'Nombre de noeuds',
            'PeoplephoneHostedSummary': 'Aperçu peoplefone HOSTED',
            'TotalOfUsers': 'Total des utilisateurs',
            'TotalOfIVRNodes': 'Total des noeuds IVR',
            'TotalMonthlyCosts': 'Total des coûts mensuels',

            'TotalUniqueCosts': 'Total des coûts  uniques',

            'PeoplephoneSoftphone': 'peoplefone SOFTPHONE',
            'PeoplephoneConnectorStandard': 'peoplefone CONNECTOR Standard',
            'PeoplephoneConnectorApi': 'peoplefone CONNECTOR API',

            'TotalOfSoftphone' : 'Total des utilisateurs peoplefone SOFTPHONE',
            'TotalConnectorStandard' : 'Total des utilisateurs peoplefone CONNECTOR Standard',
            'TotalConnectorApi' : 'Total des utilisateurs peoplefone CONNECTOR API',

            'quantityuser' : 'quantité d\'utilisateur',
            'AddPayingHosted' : 'Fonctions payantes supplémentaires',
            'adresseInput' : 'Adresse d\'installation',
            /// FLAT RATE HOSTED
            // tslint:disable-next-line:max-line-length
            'SelectSubscriptionForBusinessFlatRatesForPeoplefoneHostedHere': 'Sélectionner l\'abonnement des forfaits pour peoplefone HOSTED',
            'TheFlatRatesForPeopleFoneHostedAreDefinedPerUser': 'Le nombre de forfait pour peoplefone HOSTED est défini par utilisateur.',
            'users': 'Utilisateurs',
            // tslint:disable-next-line:max-line-length
            'TheNumberOfSelectedFlatRatesLimitsTheNumberOfOutgoingVoiceChannels': 'Le nombre d\'utilisateurs choisi limite le nombre d\'appels simultanés en sortie.',
            'CanBeAdjustedAtAnyTime': 'Ce nombre peut être en tout temps adapté',
            // tslint:disable-next-line:max-line-length
            'TheNumbersOfSelectedFlatRatesUsers': 'Le nombre d\'utilisateurs choisi ne limite pas le nombre d\'appels simultanés en entrée.',
            'DoesNotLimitTheNumberOfIncommingVC': 'Ne limite pas le nombre d\'appels simultanés en entrée',
            // tslint:disable-next-line:max-line-length
            'TheMonthlyIncludedMinutesOfTheSubscriptionAreAvailableForEveryoneWithinTheAccount': 'La consommation mensuelle est cumulée pour tous les utilisateurs/canaux du compte peoplefone.',
            // tslint:disable-next-line:max-line-length
            'TheMinimalContractPeriodForBusinessFlatRateIs12MonthsWithCancelationPeriodOf3Months': 'La durée minimum des forfaits entreprise de peoplefone est de 12 mois avec 3 mois de délai de résiliation',
            'TotalMinutes': 'Minutes totales',
            'NetworkType': 'FLAT',
            'NbrOfUsers': 'Nombre d\'utilisateur',
            'FixNet': 'Réseau fixe',
            'MobileNet': 'Réseau mobile',
            'Channels': 'Canaux',

            /// MITEL HOSTED
            'presentatMitel': '<h2>Peoplefone MITEL HOSTED - Une approche tout-en-un</h2>' +
              ' <p>peoplefone MITEL HOSTED ne peut être commandé et installé qu\'en collaboration avec un partenaire Mitel certifié.</p>',
            'MIVO-OPI' : 'Hébergement de l’application MIVO400 OIP (CTI), sans licences :',
            'abonnementMitel': 'Abonnement peoplefone MITEL HOSTED',
            'MIVO-hosted': 'Hébergement de la solution de base MIVO400VA Hosted, sans licences :',
            'machine-supp': '- 1 machine virtuelle redondante avec VPN <br>' +
              '- Mise en service et maintenance',
            'aboonementSupp': 'Abonnements supplémentaires',
            'MIVO-cloudLink': 'Hébergement de l’application MIVO400 CloudLink (Intégraton GSM /\n' +
              'MoMa), sans licences :',
            'MIVO-telework': 'Hébergement de l’application MIVO400 MBG (Teleworker), sans licences :',
            'capacite': 'Pour une capacité :',
            'link_vpn': 'Liaison(s) VPN supplémentaire(s) pour site(s) supplémentaire(s) :',
            'up to 125 terminals': 'jusqu\'à  125 terminaux',
            'up to 250 terminals': 'jusqu\'à  250 terminaux',
            'up to 1250 terminals': 'jusqu\'à  1250 terminaux',
            'up to 50 users': 'jusqu\'à 50 utilisateurs',
            'up to 300 users': 'jusqu\'à 300 utilisateurs',
            'up to 1200 users': 'jusqu\'à 1200 utilisateurs',
            /// FLAT RATE SIP-TRUNK
            // tslint:disable-next-line:max-line-length
            'SelectSubscriptionForBusinessFlatRatesForPeoplefoneSIPTRUNKHere': 'Sélectionnez ici l\'abonnement des forfaits peoplefone SIP-TRUNK',
            'NbrOfVoiceChannels': 'Nombre de canal',

            'TheFlatRatesForPeopleFoneSIPTRUNKAreDefinedPerVC': 'Le nombre de forfait pour peoplefone SIP-TRUNK est défini par canal.',
            // tslint:disable-next-line:max-line-length
            'TheNumberOfSelectedFlatRatesLimitsTheNumberOfOutgoingVC': 'Le nombre de canaux choisi limite le nombre d\'appels simultanés en sortie.',
            'VC': 'Canaux',
            'TheNumbersOfSelectedFlatRatesVC': 'Le nombre de canaux choisi ne limite pas le nombre d\'appels simultanés en entrée.',



            /// POEPLEFONE DEVICES DATA BASE
            'MyBag': 'Mon panier',
            'PeoplefoneDevicesDataBase': 'Base de données des appareils peoplefone',
            'Pos': 'Pos.',
            'Qty': 'Quantité',
            'TotalIntermediary': 'Total intermédiaire',
            'ShippingCost': 'Coûts de livraison',
            'Discount': 'Rabais',
            'TotalWithoutTaxes': 'Total sans TVA',
            'Taxes7': 'TVA',
            'TotalWithTaxes': 'Total inclu TVA',
            'ContinueShopping': 'Continuer mes achats',
            'GoToProjectSummary': 'Continuer l\'aperçu d\'offre',
            'DeskTelephone': 'Téléphones de table',
            'CordlessTelephone': 'Téléphones sans fil',
            'VoIPAdapters': 'Adaptateur VoIP',
            'PCApp': 'PCApp / smartphone App',
            'Accessories': 'Accessoires',
            'Router/Firewall/Switch': 'Router / Pare-feu / Switch',
            'MyArticles': 'Mes produits',
            'DeviceAddedToBag': 'L\'appareil a été ajouté au panier',
            'DeviceAddedToMyDevices': 'L\'appareil a été ajouté à Mes Appareils',


            // MY DEVICES
            'AddNewArticles': 'Ajouter nouveau produit',
            'AddNewArticle': 'Ajouter nouveau produit',
            'SaveAddNextArticle': 'Sauvegarder et ajouter prochain produit',
            'Back': 'Retour à la liste',


            // OFFER SUMMARY
            'Model': 'Modèle',
            'Details': 'Détails',
            'Bandwidths/IPaddress': 'Bande passante/adresses IP',
            'Total': 'Total',
            'SLA24/24': 'SLA',
            'PortedPhoneNumbers': 'Numéro de téléphone porté',
            'Numbers': 'Numéro de téléphone',
            'UsersNodes': 'Utilisateurs / noeuds',
            'CostsOfPP': 'Services/Produits peoplefone',
            'TotalCostsOfPP': 'Total des produits et services peoplefone',
            'TotalMaterialsOfPP': 'Total des produits et services du partenaire',
            'DiscountMaterialsOfPP': 'Rabais des produits et services du partenaire',
            'TotalDiscount': 'Rabais total (coûts unique)',
            'TotalMaterialsOfPPDiscount': 'Total des produits et services du partenaire (rabais inclus)',
            'PPDevicesDataBase': 'Services/Produits Complementaires',
            'NiceNumbers': 'Numéros spéciaux',
            'OfferConditionsText': '<b>Ceci est seulement une offre.<br />' +
              'Une fois l\'offre validée, les contrats peoplefone correspondants doivent être signés séparément et envoyés à peoplefone.</b>',
            'OfferConditionsLabel': 'J’ai compris la différence entre offre et contrat.',
            'exportHasNoVATLabel': 'Exporter l\'offre sans TVA incluse',


            // MANAGEMENT
            'ManagementPeoplefoneDevicesDataBase': 'Gestion des appareils peoplefone',

            // MANAGEMENT MY DEVICES
            'ManagementMyDevicesDataBase': 'Gestion des "Mes Appareils"',

            // SUMMARY
            'CostsSummary': 'Aperçu coûts',
            'TotalOfMonthlyCosts(VAT)': 'Total des coûts mensuels (TVA inclus)',
            'TotalOfUniqueCosts(VAT)': 'Total des coûts unfiques (TVA inclus)',
            'TotalCosts(VATincluded)': 'Total des coûts (TVA inclus)',
            'VATAcronym': 'TVA',

            // EDIT DEVICES
            'Image': 'Image',
            'Link': 'Lien',
            'TitleDescription': 'Titre et description',
            'PurchasePrice': 'Prix d\'achat',
            'SalesPrice': 'Prix de vente',
            'DeviceSaved': 'Appareil a été sauvegardé.',
            'PleaseProvideProperPriceValue': 'Veuillez indiquer une valeur de prix appropriée !',

            // Peoplefone Bundle
            'BundleHeadline': 'peoplefone BUNDLE',
            'BundleType': 'Abonnement',
            'BundleOptions': 'Options',
            'BundleInternetProvider': 'Fournisseur Internet',
            'BundleAddon': 'Complément',
            'BundlePortedNumbers': 'Portage de numéro',
            'BundlePortedNumbersNone': 'Pas de portage',
            'BundlePortedNumbersMSN': 'Multi Line',
            'BundlePortedNumbersDDI': 'Business Line',
            'BundleRouterText': 'Le routeur Internet n\'est pas inclus dans le peoplefone BUNDLE ' +
              'et doit être commandé séparément. Vous trouverez nos options de routeur sous "Appareils peoplefone". ' +
              'Vous pouvez également ajouter d\'autres routeurs sous "Mes appareils".',
            'BundleIPWorldcom': 'IP Worldcom',
            'BundleCyberlink': 'Cyberlink',
            'BundleRouter': 'Routeur',
            'No router': 'Pas de routeur',

            // Peolefone Microsoft Teams
            'TeamsHeadline': 'peoplefone MICROSOFT TEAMS Direct Routing',
            'OperatorConnectHeadline': 'peoplefone MICROSOFT TEAMS Operator Connect',
            'SBCplusHeadline': 'peoplefone MICROSOFT TEAMS SBCplus',
            'TeamsAmount': 'Nombre',
            'TeamsUsers': 'Canaux vocaux (min. 2)',
            'TeamsSetup': 'Mise en service',
            'TeamsSetupDesc': 'Mise en service de Microsoft Teams',

            // Peoplefone 3CX
            '3cx': '3CX',
            '3cxHeadline': 'peoplefone 3CX HOSTED',
            '3cxOptions': 'Options',
            '3cxType': 'Edition',
            '3cxTypeUnlicensed': 'Sans license',
            '3cxTypeStandard': 'Standard - plus disponible',
            '3cxTypeProfessional': 'Professional',
            '3cxTypeEnterprise': 'Enterprise',

            '3cxUnlicensed8' : 'Standard',
            '3cxUnlicensed16' : 'Medium',
            '3cxUnlicensed96' : 'Large',
            '3cxUnlicensed512' : 'Enterprise',

            '3cxTerm': 'Période minimale du contrat',
            '3cxTerm12': '12 mois',
            '3cxTerm24': '24 mois',
            '3cxSC': 'SC / Variant',
            '3cxSCs': 'SC',
            '3cxAddon': 'Extensions',
            '3cxAddonStorage': 'Espace de stockage supplémentaire',
            '3cxAddonStorageNone': 'Sans',
            '3cxAddonStorageExtension64': '64 GB',
            '3cxAddonStorageExtension96': '96 GB',
            '3cxAddonStorageExtension128': '128 GB',
            '3cxSummary': 'Apercu 3CX HOSTED',
            '3cxMonths': 'mois',

            // peoplefone Internet
            'DSL/FIBER' : 'peoplefone Internet (DSL/FIBER)',

             //peoplefone MOBILE
             'MobileHeadline' : 'peoplefone MOBILE',
             'MobileSubscription' : 'Abonnement',
             'Extra Cards' : 'Carte supplémentaire',
             'Extra Cards Data' : 'Carte supplémentaire (Data)',
             'Extra Cards Watch' : 'Carte supplémentaire (Montre)'
          });
      }

      case 'pl': {
        // return Observable.of(
        //   {

        //     /// LOGIN
        //     'WelcomePeoplefoneSalesTool': 'Witaj w menadżerze sprzedaży peoplefone',
        //     'AccessAccount': 'Dostęp do konta',
        //     'LoginID': 'Login ID',
        //     'EnterReselerID': 'Wpisz numer ID',
        //     'Password': 'Hasło',
        //     'EnterReselerPW': 'Wpisz hasło',
        //     'LOGIN': 'ZALOGUJ',


        //     /// TOP BAR
        //     'Logout': 'Wyloguj',


        //     /// SIDE BAR
        //     'AllOffers': 'Wszystkie oferty',
        //     'FollowUp': 'Follow Up',
        //     'Business': 'Biznes',
        //     'OfferSummary': 'Podsumowanie oferty',
        //     'Management': 'Zarządzanie',
        //     'Previous': 'Poprzedni',
        //     'Next': 'Następny',
        //     'NewOffer': 'Nowa oferta',
        //     'Editffer': 'Edytuj ofertę',
        //     'ManagementOfMyDevices': 'Zarządzanie urządzeniami',


        //     /// MY OFFER COMPONENT
        //     'MyOffers': 'Moja oferta',
        //     'Overview': 'Przegląd',
        //     'People': 'People',
        //     'Period': 'Period',
        //     'OpenedOffers': 'Otwarte oferty',
        //     'WonOffers': 'Wygrane oferty',
        //     'LostOffers': 'Stracone oferty',
        //     'MonthlyCostRealized': 'Dochód roczny',
        //     'UniqueCostRealized': 'Dochód roczny',
        //     'PotentialMonthlyCost': 'Dochód roczny',
        //     'PotentialUniqueCost': 'Dochód roczny',
        //     'AddNewOffer': 'Add new offer',
        //     'SearchOffers': 'Wyszukaj oferty',
        //     'OfferStatus': 'Status oferty',
        //     'OfferNumber': 'Numer oferty',
        //     'CompanyName': 'Nazwa firmy',
        //     'ContactPerson': 'Osoba kontaktowa',
        //     'PostalCode': 'Kod pocztowy',
        //     'City': 'Miasto',
        //     'PhoneNumber': 'Tel. stacjonarny',
        //     'MobileNumber': 'Tel. komórkowy',
        //     'SalesStage': 'Etap sprzedaży',
        //     'NextStep': 'Następny etap',
        //     'DateFrom': 'Data - od',
        //     'DateTill': 'Data - do',
        //     'Search': 'Wyszukaj',
        //     'Cancel': 'Anuluj',
        //     'SelectedOffers': 'Wybrane oferty',
        //     'No': 'Nr',
        //     'OfferNr': 'Nr oferty',
        //     'DateIN': 'Data utworzenia',
        //     'NextDate': 'Następna data',
        //     'Customer': 'Klient',
        //     'FollowUP': 'Follow UP',
        //     'Read': 'Odczyt',
        //     'Edit': 'Edycja',
        //     'Save': 'Zapisz',
        //     'Duplicate': 'Duplikuj',
        //     'Delete': 'Usuń',
        //     'PrintOffer': 'Drukuj',
        //     'ExportDocFile': 'Export .doc file',

        //     /// FOLLOW UP COMPONENT
        //     'ProjectFollowUp': 'Follow up projektu',
        //     'DescriptionOfTheProject': 'Opis projektu',
        //     'Date': 'Data',
        //     'Contact': 'Kontakt',
        //     'Visit': 'Spotkanie',
        //     'SendOffer': 'Wyślij ofertę',
        //     'WaitingFeedback': 'Oczekiwanie na informację zwrotną',
        //     'ReminderNextDate': 'Przypomnij datę',
        //     'AddFollowUp': 'Dodaj follow up',
        //     'EditOffer': 'Edycja oferty',


        //     /// CUSTOMER PROFILE
        //     'CustomerProfile': 'Profil klienta',
        //     'CoordinatesOfTheCustomer': 'Dane klienta',
        //     'Complement': 'Uzupełnienie',
        //     'AddressNBR': 'Adres',
        //     'FurtherAddress': 'Adres 2',
        //     'LastName': 'Nazwisko',
        //     'FirstName': 'Imię',
        //     'Position': 'Stanowisko',
        //     'EmailAddress': 'Email',
        //     'LanguagePost': 'Język korespondencji',
        //     'SelectLanguage': 'Wybierz język',
        //     'Offer': 'Oferta',
        //     'AddNewContactPerson': 'Dodaj nowy kontakt',
        //     'Update': 'Aktualizuj',


        //     /// SELECT WISHED SOLUTION
        //     'SelectTheWishedSolution': 'Wybierz rozwiązanie',
        //     'PeoplephoneInternetIPworldcom': 'peoplefone Internet IP Worldcom',
        //     'PeoplephoneInternetCyberlink': 'peoplefone Internet Cyberlink',
        //     'PhoneNumbersToBePorted': 'Numery telefonów do przeniesienia',
        //     'NewPhoneNumbers': 'Nowe numery',
        //     'PeoplephoneHosted': 'peoplefone HOSTED',
        //     'FlatRateHOSTED': 'Flat Rate HOSTED',
        //     'FlatRateSIPTRUNK': 'Flat Rate SIP-TRUNK',
        //     'PeoplephoneDevicesDataBase': 'Baza danych urządzeń peoplefone',
        //     'MyDevicesDataBase': 'Baza danych moich urządzeń',
        //     '3CX': '3CX',
        //     'MicrosoftTeams': 'Microsoft Teams',


        //     /// PEOPLEPHONE IPworldcom
        //     'MyOffer': 'Moja oferta',
        //     'Technology': 'Technologia',
        //     'Bandwidths': 'Przepustowość',
        //     'IPaddress': 'Adres IP',
        //     'MonthlyCosts': 'Koszt miesięczny',
        //     'UniqueCosts': 'Koszty dodatkowe',
        //     'Internet': 'Internet',
        //     'Asymmetric': 'Asymetryczny',
        //     'Symmetric': 'Symetryczny',
        //     'SupportTime': 'Czas wsparcia',
        //     'TypeOfRouter': 'Typ routera',
        //     'AddInternetConnection': 'Dodaj połączenie z Internetem',


        //     /// PHONE NUMBERS TO BE PORTED
        //     // tslint:disable-next-line:max-line-length
        //     'SelectHereAllTheRangesOfNumbersToBePortedByPeoplephone': 'Wybierz tutaj wszystkie zakresy numerów do przeniesienia przez Peoplefone',
        //     'ConnectionType': 'Typ połączenia',
        //     'totalCount': 'Wszystkie numery',
        //     'Range': 'Zakres',
        //     'EconomyLine': 'Linia ekonomiczna',
        //     'MultiLine': 'Multilinia',
        //     'BusinessLineDDI': 'Business Line - DDI',
        //     'SCBusinessLineGRA': 'SC Business Line GRA',
        //     'InternatNumbers': 'Numery międzynarodowe',
        //     'AddNewRange': 'Dodaj nowy zakres',


        //     /// NEW PHONE NUMBERS
        //     'TotalWishedNumbers': 'Wszystkie numery',
        //     'OfferedNumbers': 'Oferowane numery',
        //     'NiceNumber': 'Super numer',
        //     'Category': 'Kategoria',
        //     'SelectAllTheRangesOfNewPeoplefonePhoneNumbersHere': 'Wybierz tutaj wszystkie zakresy nowych numerów w Peoplefone',

        //     /// PEOPLEPHONE HOSTED
        //     // tslint:disable-next-line:max-line-length
        //     'SelectHereTheNumberOfUsersFaxAnsweringMachinesReserveOfUsersAndIVRNode': 'Wybierz liczbę użytkowników, faksów, automatycznych sekretarek, rezerwę użytkowników i węzeł IVR',
        //     'Users': 'Użytkownicy',
        //     'NumbersOfUsersIPTerminals': 'Liczba użytkowników (terminale IP)',
        //     'NumberOfFaxToEmailRequiresUser': 'Numer faksu do e-mail (wymaga 1 użytkownika)',
        //     'NumberOfAnalogRequiresUser': 'Licza analogów (wymaga 1 użytkownika)',
        //     'NumberOfCentralizedVoiceMailRequiresUser': 'Liczba scentralizowanej poczty głosowej (wymaga 1 użytkownika)',
        //     'ReserveOfUsers': 'Rezerwa użytkowników',
        //     'TotalOfTheSelectedUsers': 'Łącznie wybranych użytkowników',
        //     'TotalOfAvailableUsersInTheProposedHOSTEDSolution': 'Łącznie dostępnych użytkowników w rozwiązaniu HOSTED',
        //     'AllAnalogTerminalsRequiresCiscoSPA122Box': 'Wszystkie terminale analogowe wymagają 1 Cisco SPA 122',
        //     'NumberOfCiscoBoxWith2ConnectedAnalogsTerminals': 'Liczba boxów Cisco połączonych z 2 terminalami analogowymi',
        //     'NumberOfCiscoSPA122Box': 'Liczba boxów Cisco SPA 122',
        //     'AddTheNumberOfCiscoSPA122BoxInTheShopPage': '(dodaj liczbę boxów Cisco SPA 122 na stronie zakupów)',
        //     'PeoplephoneHostedIVR': 'Peoplefone Hosted IVR',
        //     'Nodes': 'Węzły',
        //     'NumberOfNodes': 'Liczba węzłów',
        //     'PeoplephoneHostedSummary': 'PEOPLEFONE HOSTED PODSUMOWANIE',
        //     'TotalOfUsers': 'Liczba wszystkich użytkowników',
        //     'TotalOfIVRNodes': 'Liczba wszystkich węzłów IVR',
        //     'TotalMonthlyCosts': 'Całkowity koszt miesięczny',


        //     /// PEOPLEPHONE HOSTED
        //     // tslint:disable-next-line:max-line-length
        //     'SelectSubscriptionForBusinessFlatRatesForPeoplefoneHostedHere': 'Wybierz tutaj subskrypcję stawek ryczałtowych dla HOSTED',
        //     'TheFlatRatesForPeopleFoneHostedAreDefinedPerUser': 'łamana angielszczyzna',
        //     // tslint:disable-next-line:max-line-length
        //     'TheMinimalContractPeriodForBusinessFlatRateIs12MonthsWithCancelationPeriodOf3Months': 'Minimalny okres umowy na zryczałtowaną stawkę biznesową wynosi 12 miesięcy, a okres anulowania wynosi 3 miesiące',
        //     'TotalMinutes': 'Liczba wszystkich minut',
        //     'NetworkType': 'Typ sieci',
        //     'NbrOfUsers': 'Liczba użytkowników',
        //     'FixNet': 'FixNet',
        //     'MobileNet': 'MobileNet',


        //     /// FLAT RATE SIP-TRUNK
        //     // tslint:disable-next-line:max-line-length
        //     'SelectSubscriptionForBusinessFlatRatesForPeoplefoneSIPTRUNKHere': 'Wybierz tutaj subskrypcję stawek ryczałtowych dla SIP-TRUNK',
        //     'NbrOfVoiceChannels': 'Liczba kanałów głosowych',


        //     /// POEPLEFONE DEVICES DATA BASE
        //     'PeoplefoneDevicesDataBase': 'Baza danych urządzeń Peoplephone',
        //     'Pos': 'Pos.',
        //     'Description': 'Opis',
        //     'Qty': 'Qty',
        //     'TotalIntermediary': 'Total intermediary',
        //     'ShippingCost': 'Cena wysyłki',
        //     'Discount': 'Zniżka',
        //     'TotalWithoutTaxes': 'Koszt całkowity bez VAT',
        //     'Taxes7': 'VAT 7.7%',
        //     'TotalWithTaxes': 'Koszt całkowity z VAT',
        //     'ContinueShopping': 'Kontynuuj zakupy',
        //     'GoToProjectSummary': 'Podsumowanie oferty',
        //     'DeskTelephone': 'Desk Telephone',
        //     'CordlessTelephone': 'Cordless Telephone',
        //     'VoIPAdapters': 'VoIP Adapters',
        //     'PCApp': 'PCApp / smartphone App',
        //     'Accessories': 'Akcesoria',
        //     'Router/Firewall/Switch': 'Router / Firewall / Switch',
        //     'MyArticles': 'Moje artykuły',

        //     // MY DEVICES
        //     'AddNewArticles': 'Dodaj nowe artykuły',
        //     'AddNewArticle': 'Dodaj nowy artykuł',


        //     // OFFER SUMMARY
        //     'Model': 'Model',
        //     'Bandwidths/IPaddress': 'Bandwidths/IP address',
        //     'Total': 'Total',
        //     'SLA24/24': 'SLA 24/24-365j-8h',
        //     'PortedPhoneNumbers': 'Ported phone numbers',
        //     'Numbers': 'Numbers',
        //     'UsersNodes': 'Users / nodes',
        //     'CostsOfPP': 'Costs od Peoplefone',
        //     'TotalCostsOfPP': 'Total costs of Peoplefone',
        //     'TotalMaterialsOfPP': 'Total materials of Peoplefone devices data base',
        //     'DiscountMaterialsOfPP': 'Discount of the materials of Peoplefone devices data base',
        //     'TotalDiscount': 'Total discount (unique costs)',
        //     'TotalMaterialsOfPPDiscount': 'Total materials of Peoplefone devices data base (discount included)',
        //     'PPDevicesDataBase': 'Peoplefone devices data base',


        //     // MANAGEMENT
        //     'ManagementPeoplefoneDevicesDataBase': 'Zarządzanie bazą danych Peoplefone',

        //     // MANAGEMENT MY DEVICES
        //     'ManagementMyDevicesDataBase': 'Zarządzanie moimi urządzeniami',
        //   });

      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/languageLoader.ts